// File: src/pages/UserOpeningClosingBalance.jsx

import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Card, Spinner, Input } from "reactstrap";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import swal from "sweetalert";

import {
  FaEdit,
  FaDownload,
  FaFileExcel,
  FaFilePdf,
  FaChevronDown,
} from "react-icons/fa";

import api from "../import/axiosConfig";

import {
  CreateAccountUpdate,
  CreateCustomerList,
  CreateCustomerUpdate,
  _Get,
  _Put,
  PurchaseOrderList,
  createOrderhistoryviewDATABASE,
} from "../import/ApiEndPoint/ApiCalling";

import {
  View_User_By_Id2,
  View_Ledger_by_id_database,
  Create_Transporter_List,
  Update_TransporterByID,
  PurchaseProductList_Product,
  WareHouse_Closing_Stock,
  Update_Product,
} from "../import/ApiEndPoint/Api";

import RupioSoftLogo from "../import/logo.png";
import { baseURL } from "../import/ApiEndPoint/TestApi";

/* =========================================================
   CONSTANTS
========================================================= */

const TABS = [
  { key: "users", label: "User List" },
  { key: "accounts", label: "Account List" },
  { key: "customers", label: "Customer List" },
  { key: "transporters", label: "Transporter List" },
  { key: "products", label: "Product List" },
];

const ACCOUNT_TYPES = [
  "Capital Account",
  "Reserves and Surplus",
  "Current Liabilities",
  "Sundry Creditors",
  "Duties and Taxes",
  "Provisions",
  "Bank OCC Account",
  "Bank OD Account",
  "Secured Loans",
  "Unsecured Loans",
  "Deposits (Liability)",
  "Fixed Assets",
  "Investments",
  "Current Assets",
  "Bank Accounts",
  "Cash-in-Hand",
  "Deposits (Asset)",
  "Loans and Advances (Asset)",
  "Stock-in-Hand",
  "Sundry Debtors",
  "Sales Account",
  "Purchase Account",
  "Direct Incomes",
  "Indirect Incomes",
  "Direct Expenses",
  "Indirect Expenses",
  "Branch/Divisions",
  "Misc. Expenses (Asset)",
];

const PAGE_SIZE = 100;
const BALANCE_REQUEST_CONCURRENCY = 12;

/* =========================================================
   CSS
========================================================= */

const injectOnce = () => {
  const id = "user-opening-closing-balance-css";
  if (document.getElementById(id)) return;

  const style = document.createElement("style");
  style.id = id;
  style.innerHTML = `
    .ucb-shell{
      border-radius:18px;
      border:1px solid #e5e7eb;
      background:#ffffff;
      box-shadow:0 10px 24px rgba(0,0,0,0.06);
      overflow:hidden;
    }

    .ucb-tabsbar{
      width:100%;
      background:#ffffff;
      border-bottom:1px solid #eef2f7;
      padding:10px 12px;
    }

    .ucb-tabswrap{
      position:relative;
      width:100%;
      display:flex;
      align-items:center;
      justify-content:center;
    }

    .ucb-tabs{
      width:100%;
      display:flex;
      align-items:center;
      justify-content:center;
      position:relative;
      border-radius:14px;
      background:#f8fafc;
      border:1px solid #e5e7eb;
      overflow:hidden;
    }

    .ucb-tab{
      flex:1 1 0;
      text-align:center;
      border:none;
      background:transparent;
      padding:10px 12px;
      font-weight:900;
      font-size:14px;
      color:#0f172a;
      cursor:pointer;
      position:relative;
      z-index:2;
      user-select:none;
      transition:color .2s ease, transform .15s ease;
    }

    .ucb-tab:hover{ transform:translateY(-1px); }
    .ucb-tab.active{ color:#ffffff; }

    .ucb-indicator{
      position:absolute;
      top:0;
      left:0;
      height:100%;
      border-radius:14px;
      background:linear-gradient(90deg,#2563eb,#1d4ed8);
      transition:transform .28s cubic-bezier(.2,.8,.2,1);
      box-shadow:0 10px 18px rgba(37,99,235,0.22);
      z-index:1;
    }

    .ucb-actionbar{
      width:100%;
      padding:12px;
      background:#ffffff;
    }

    .ucb-actionrow{
      display:flex;
      align-items:center;
      gap:12px;
      flex-wrap:nowrap;
    }

    .ucb-title{
      font-weight:1000;
      font-size:18px;
      letter-spacing:.02em;
      text-transform:uppercase;
      color:#0f172a;
      padding-left:6px;
      border-left:4px solid #fc8019;
      line-height:1;
      white-space:nowrap;
    }

    .ucb-count{
      margin-left:6px;
      display:inline-block;
      background:#eef2ff;
      color:#3730a3;
      font-size:12px;
      font-weight:900;
      padding:5px 9px;
      border-radius:999px;
    }

    .ucb-spacer{ flex:1 1 auto; }

    .ucb-search{
      width:360px;
      height:40px;
      border-radius:14px;
      border:1px solid #e5e7eb;
      background:#ffffff;
      padding:0 12px;
      font-weight:900;
      outline:none;
      box-shadow:0 8px 16px rgba(0,0,0,0.04);
    }

    .ucb-search:focus{
      border-color:#93c5fd;
      box-shadow:0 0 0 4px rgba(59,130,246,0.18);
    }

    .ucb-btn-primary{
      height:40px;
      padding:0 14px;
      border-radius:14px;
      font-weight:1000;
      letter-spacing:.02em;
      text-transform:uppercase;
      border:1px solid #2563eb;
      background:#2563eb;
      color:#fff;
      display:inline-flex;
      align-items:center;
      justify-content:center;
      gap:8px;
      cursor:pointer;
      box-shadow:0 10px 18px rgba(37,99,235,0.20);
      transition:transform .12s ease, filter .12s ease;
      white-space:nowrap;
    }

    .ucb-btn-primary:hover{
      transform:translateY(-1px);
      filter:brightness(.98);
    }

    .ucb-btn-soft{
      height:40px;
      padding:0 12px;
      border-radius:14px;
      border:1px solid #e5e7eb;
      background:#fff;
      font-weight:1000;
      letter-spacing:.02em;
      text-transform:uppercase;
      display:inline-flex;
      align-items:center;
      justify-content:center;
      gap:8px;
      cursor:pointer;
      box-shadow:0 8px 16px rgba(0,0,0,0.04);
      transition:transform .12s ease, box-shadow .12s ease;
      white-space:nowrap;
    }

    .ucb-btn-soft:hover{
      transform:translateY(-1px);
      box-shadow:0 12px 22px rgba(0,0,0,0.08);
    }

    .ucb-download-wrap{ position:relative; }

    .ucb-download-menu{
      position:absolute;
      right:0;
      top:48px;
      width:180px;
      background:#ffffff;
      border:1px solid #e5e7eb;
      border-radius:14px;
      box-shadow:0 14px 35px rgba(15,23,42,.15);
      padding:6px;
      z-index:100;
    }

    .ucb-download-item{
      width:100%;
      border:none;
      background:#ffffff;
      padding:10px 12px;
      border-radius:10px;
      display:flex;
      align-items:center;
      gap:10px;
      cursor:pointer;
      font-weight:800;
      text-align:left;
      color:#0f172a;
    }

    .ucb-download-item:hover{ background:#f8fafc; }

    .ucb-table-card{
      padding:8px;
      border-radius:14px;
      border:1px solid #e5e7eb;
      margin:0 12px 12px;
    }

    .ucb-table-wrap{
      width:100%;
      overflow:auto;
      border:1px solid #e5e7eb;
      border-radius:14px;
      background:#fff;
    }

    .ucb-table{
      width:100%;
      border-collapse:collapse;
      table-layout:auto;
      min-width:800px;
    }

    .ucb-table thead th{
      background:#f4f7f6;
      color:#0f172a;
      font-weight:1000;
      text-transform:uppercase;
      font-size:12px;
      letter-spacing:.03em;
      border-bottom:1px solid #e5e7eb;
      padding:9px 10px;
      position:sticky;
      top:0;
      z-index:1;
      text-align:center;
      white-space:nowrap;
    }

    .ucb-table tbody td{
      padding:9px 10px;
      border-bottom:1px solid #f1f5f9;
      vertical-align:middle;
      color:#0f172a;
      font-size:14px;
      text-align:center;
    }

    .ucb-table tbody tr:hover{ background:#f9fbff; }

    .ucb-particular{
      text-align:left;
      padding-left:12px;
    }

    .ucb-main-name{
      font-weight:800;
      color:#0f172a;
    }

    .ucb-ledger-link{
      border:0;
      padding:0;
      margin:0;
      background:transparent;
      color:#2563eb;
      font:inherit;
      font-weight:800;
      text-align:left;
      cursor:pointer;
      text-decoration:none;
    }

    .ucb-ledger-link:hover{
      color:#1d4ed8;
      text-decoration:underline;
    }

    .ucb-ledger-link:focus-visible{
      outline:2px solid #93c5fd;
      outline-offset:3px;
      border-radius:4px;
    }

    .ucb-sub-name{
      margin-top:2px;
      font-size:11px;
      color:#64748b;
      font-weight:700;
    }

    .ucb-money{
      font-weight:800;
      white-space:nowrap;
    }

    .ucb-balance-type{
      font-size:11px;
      color:#64748b;
      margin-left:4px;
      font-weight:700;
    }

    .ucb-fy-pill{
      display:inline-block;
      padding:4px 9px;
      background:#eff6ff;
      color:#1d4ed8;
      border-radius:999px;
      font-size:12px;
      font-weight:800;
    }

    .ucb-empty{
      padding:30px;
      text-align:center;
      color:#6b7280;
      font-weight:600;
    }

    .ucb-modal-table-wrap{
      max-height:62vh;
      overflow:auto;
      border:1px solid #e5e7eb;
      border-radius:12px;
    }

    .ucb-modal-table{
      width:100%;
      border-collapse:collapse;
      min-width:850px;
    }

    .ucb-modal-table th{
      position:sticky;
      top:0;
      z-index:2;
      background:#f4f7f6;
      padding:8px;
      border-bottom:1px solid #e5e7eb;
      text-align:center;
      font-size:12px;
      text-transform:uppercase;
      white-space:nowrap;
    }

    .ucb-modal-table td{
      padding:8px;
      border-bottom:1px solid #f1f5f9;
      vertical-align:middle;
    }

    .ucb-modal-table .form-control{
      min-width:125px;
      height:36px;
      font-size:13px;
    }

    .ucb-modal-user{ min-width:180px; }
    .ucb-dirty-row{ background:#fff7ed; }

    .ucb-error-text{
      color:#dc2626;
      font-size:11px;
      margin-top:4px;
      font-weight:700;
    }


    .ucb-table{ min-width:1550px; }

    .ucb-th-wrap{
      display:flex;
      align-items:center;
      justify-content:center;
      gap:6px;
      min-height:26px;
    }

    .ucb-col-edit-btn,
    .ucb-col-save-btn,
    .ucb-col-cancel-btn{
      width:25px;
      height:25px;
      border-radius:8px;
      border:1px solid #dbe2ea;
      background:#fff;
      display:inline-flex;
      align-items:center;
      justify-content:center;
      cursor:pointer;
      padding:0;
      transition:transform .12s ease, box-shadow .12s ease;
    }

    .ucb-col-edit-btn:hover,
    .ucb-col-save-btn:hover,
    .ucb-col-cancel-btn:hover{
      transform:translateY(-1px);
      box-shadow:0 6px 12px rgba(15,23,42,.10);
    }

    .ucb-col-edit-btn{ color:#2563eb; }
    .ucb-col-save-btn{ color:#047857; }
    .ucb-col-cancel-btn{ color:#b91c1c; }

    .ucb-col-edit-btn:disabled,
    .ucb-col-save-btn:disabled,
    .ucb-col-cancel-btn:disabled{
      opacity:.45;
      cursor:not-allowed;
      transform:none;
      box-shadow:none;
    }

    .ucb-current-year-cell{
      background:#f8fbff;
    }

    .ucb-inline-input{
      min-width:112px;
      height:32px;
      border:1px solid #cbd5e1;
      border-radius:9px;
      padding:4px 8px;
      font-size:12px;
      font-weight:700;
      outline:none;
      background:#fff;
    }

    .ucb-inline-input:focus{
      border-color:#60a5fa;
      box-shadow:0 0 0 3px rgba(59,130,246,.13);
    }

    .ucb-inline-name{
      min-width:190px;
      text-align:left;
    }

    .ucb-inline-balance{
      display:flex;
      align-items:center;
      justify-content:center;
      gap:5px;
      min-width:180px;
    }

    .ucb-inline-balance .ucb-inline-input{
      min-width:105px;
      width:105px;
      text-align:right;
    }

    .ucb-inline-type{
      width:60px;
      min-width:60px;
      height:32px;
      border:1px solid #cbd5e1;
      border-radius:9px;
      font-size:12px;
      font-weight:800;
      background:#fff;
    }

    .ucb-editing-cell{
      background:#fff7ed !important;
    }

    .ucb-pagination{
      display:flex;
      align-items:center;
      justify-content:flex-end;
      gap:8px;
      padding:10px 4px 2px;
      font-size:12px;
      font-weight:800;
      color:#475569;
    }

    .ucb-page-btn{
      height:32px;
      padding:0 11px;
      border-radius:9px;
      border:1px solid #dbe2ea;
      background:#fff;
      color:#0f172a;
      font-weight:800;
      cursor:pointer;
    }

    .ucb-page-btn:disabled{
      opacity:.45;
      cursor:not-allowed;
    }

    .ucb-year-label{
      font-weight:900;
      color:#1e3a8a;
      white-space:nowrap;
    }

    @media(max-width:900px){
      .ucb-actionrow{ flex-wrap:wrap; }
      .ucb-search{ width:100%; order:10; }
      .ucb-spacer{ display:none; }
    }
  `;

  document.head.appendChild(style);
};

/* =========================================================
   BASIC HELPERS
========================================================= */

const toStr = (value) =>
  value === null || value === undefined ? "" : String(value);

const safeNum = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

const normalizeBalanceType = (value) => {
  const raw = String(value || "")
    .trim()
    .toLowerCase();
  if (["debit", "dr", "d"].includes(raw)) return "debit";
  if (["credit", "cr", "c"].includes(raw)) return "credit";
  return raw;
};

const formatAmount = (value) =>
  new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Math.abs(safeNum(value)));

const formatBalance = (amount, type = "") => {
  const normalizedType = normalizeBalanceType(type);
  let suffix = "";
  if (normalizedType === "debit") suffix = " Dr";
  if (normalizedType === "credit") suffix = " Cr";
  return `₹ ${formatAmount(amount)}${suffix}`;
};

const formatBalanceForPdf = (amount, type = "") => {
  const normalizedType = normalizeBalanceType(type);
  let suffix = "";
  if (normalizedType === "debit") suffix = " Dr";
  if (normalizedType === "credit") suffix = " Cr";
  return `Rs. ${formatAmount(amount)}${suffix}`;
};

/* =========================================================
   FINANCIAL YEAR HELPERS
========================================================= */

const normalizeFinancialYear = (value) => {
  const raw = String(value || "").trim();
  const match = raw.match(/^(\d{4})\s*-\s*(\d{2}|\d{4})$/);
  if (!match) return raw;

  const startYear = match[1];
  const endYear = match[2].length === 4 ? match[2].slice(-2) : match[2];
  return `${startYear}-${endYear}`;
};

const getCurrentFinancialYearLabel = (date = new Date()) => {
  const currentDate = new Date(date);
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1;
  const startYear = month >= 4 ? year : year - 1;
  return `${startYear}-${String(startYear + 1).slice(-2)}`;
};

const getActiveFinancialYear = () =>
  normalizeFinancialYear(
    localStorage.getItem("financialYearSelected") ||
      getCurrentFinancialYearLabel(),
  );

const getPreviousFinancialYear = (financialYear) => {
  const normalized = normalizeFinancialYear(
    financialYear || getActiveFinancialYear(),
  );

  const startYear = Number(String(normalized || "").split("-")[0]);
  if (!Number.isFinite(startYear)) return "";

  return `${startYear - 1}-${String(startYear).slice(-2)}`;
};

const getFYStartYear = (financialYear) => {
  const start = Number(String(financialYear || "").split("-")[0]);
  return Number.isFinite(start) ? start : 0;
};

// Build a FY label from its starting year.
const makeFinancialYearLabel = (startYear) =>
  `${startYear}-${String(startYear + 1).slice(-2)}`;

const getDisplayFinancialYears = (
  currentFinancialYear = getCurrentFinancialYearLabel(),
) => {
  const startYear = getFYStartYear(currentFinancialYear);
  if (!startYear) return [];

  return [0, 1, 2].map((offset) => makeFinancialYearLabel(startYear - offset));
};

// To calculate the opening of targetFY, carry the balance through every FY
// starting from openingFY and ending with the FY immediately before targetFY.
const getFinancialYearsForCarryForward = (openingFY, targetFY) => {
  const openingStart = getFYStartYear(openingFY);
  const targetStart = getFYStartYear(targetFY);

  if (!openingStart || !targetStart || targetStart <= openingStart) return [];

  const years = [];

  for (let year = openingStart; year < targetStart; year += 1) {
    years.push(makeFinancialYearLabel(year));
  }

  return years;
};

// Resolve the financial year from a ledger transaction date.
// IMPORTANT: Carry-forward calculations must use the same FY rows that are
// actually visible in the ledger, not blindly every row returned by an FY DB.
const getLedgerDateFinancialYear = (dateValue) => {
  if (!dateValue) return "";

  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return "";

  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const startYear = month >= 4 ? year : year - 1;

  return makeFinancialYearLabel(startYear);
};

const getLedgerRowFinancialYear = (row) =>
  getLedgerDateFinancialYear(row?.date || row?.updatedAt || row?.createdAt);

const normalizeFinancialYearsList = (value) => {
  let list = value;

  if (typeof list === "string") {
    try {
      list = JSON.parse(list);
    } catch {
      list = list
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);
    }
  }

  if (!Array.isArray(list)) return [];

  return [
    ...new Set(
      list.map((item) => normalizeFinancialYear(item)).filter(Boolean),
    ),
  ];
};

const sortFinancialYears = (list = []) =>
  [...list].sort((a, b) => getFYStartYear(a) - getFYStartYear(b));

const getKnownFinancialYears = (activeFinancialYear, extra = []) => {
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const companyDetail = JSON.parse(
    localStorage.getItem("Companydetail") || "{}",
  );

  const years = [
    ...normalizeFinancialYearsList(userData?.financialYears),
    ...normalizeFinancialYearsList(companyDetail?.financialYears),
    ...extra.map((item) => normalizeFinancialYear(item)).filter(Boolean),
    normalizeFinancialYear(activeFinancialYear),
  ].filter(Boolean);

  return sortFinancialYears([...new Set(years)]);
};

const getFinancialYearsBefore = (
  financialYears = [],
  activeFinancialYear = "",
) => {
  const activeStart = getFYStartYear(activeFinancialYear);

  return sortFinancialYears(
    financialYears.filter((financialYear) => {
      const start = getFYStartYear(financialYear);
      return start > 0 && activeStart > 0 && start < activeStart;
    }),
  );
};

const stripFinancialYearSuffix = (database) =>
  String(database || "").replace(/-\d{4}-\d{2}$/, "");

const buildDatabaseForFY = (database, financialYear) => {
  const mainDatabase = stripFinancialYearSuffix(database);
  const normalizedFinancialYear = normalizeFinancialYear(
    financialYear || getActiveFinancialYear(),
  );

  return normalizedFinancialYear
    ? `${mainDatabase}-${normalizedFinancialYear}`
    : mainDatabase;
};

/* =========================================================
   LEDGER / BALANCE HELPERS
========================================================= */

const openingToSigned = (record) => {
  const type = normalizeBalanceType(record?.openingType || record?.Type);
  const amount = safeNum(record?.openingBalance ?? record?.OpeningBalance ?? 0);

  if (type === "credit") return -amount;
  return amount;
};

const getLedgerRowsSignedMovement = (rows = []) =>
  (Array.isArray(rows) ? rows : []).reduce(
    (total, row) => total + safeNum(row?.debit) - safeNum(row?.credit),
    0,
  );

const signedBalanceInfo = (signedValue) => {
  const signed = safeNum(signedValue);

  if (signed > 0) {
    return { balance: Math.abs(signed), type: "debit" };
  }

  if (signed < 0) {
    return { balance: Math.abs(signed), type: "credit" };
  }

  return { balance: 0, type: "" };
};

/* =========================================================
   CUSTOMER PARTY TYPE HELPERS
========================================================= */

const normalizeCustomerPartyType = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

const getLedgerVoucherActivity = (rows = []) => {
  let hasDebitorActivity = false;
  let hasCreditorActivity = false;

  (Array.isArray(rows) ? rows : []).forEach((row) => {
    const voucherType = String(row?.voucherType || row?.VoucherType || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z]/g, "");

    // As requested:
    // Sales Invoice / Receipt => Debitor nature
    // Purchase Invoice / Payment => Creditor nature
    if (
      voucherType.includes("salesinvoice") ||
      voucherType.includes("saleinvoice") ||
      voucherType.includes("receipt")
    ) {
      hasDebitorActivity = true;
    }

    if (
      voucherType.includes("purchaseinvoice") ||
      voucherType.includes("purchase") ||
      voucherType.includes("payment")
    ) {
      hasCreditorActivity = true;
    }
  });

  return { hasDebitorActivity, hasCreditorActivity };
};

const resolveCustomerPartySide = (record, currentFYRows, closingType) => {
  const rawPartyType = normalizeCustomerPartyType(
    record?.partyType || record?.PartyType || record?.party_type || "",
  );

  if (["debitor", "debtor"].includes(rawPartyType)) return "debitor";
  if (["creditor", "crediter"].includes(rawPartyType)) return "creditor";

  if (rawPartyType === "ecommerce" || rawPartyType === "e-commerce") {
    const { hasDebitorActivity, hasCreditorActivity } =
      getLedgerVoucherActivity(currentFYRows);

    if (hasDebitorActivity && !hasCreditorActivity) return "debitor";
    if (hasCreditorActivity && !hasDebitorActivity) return "creditor";

    // If both transaction natures exist (or neither is identifiable),
    // classify from this FY's actual closing balance.
    if (normalizeBalanceType(closingType) === "credit") return "creditor";
    if (normalizeBalanceType(closingType) === "debit") return "debitor";

    return "";
  }

  // Backward-compatible fallback for records with no/unknown partyType.
  if (normalizeBalanceType(closingType) === "credit") return "creditor";
  if (normalizeBalanceType(closingType) === "debit") return "debitor";

  return "";
};

/* =========================================================
   LIST HELPERS
========================================================= */

const extractUserList = (responseData) => {
  if (Array.isArray(responseData?.adminDetails))
    return responseData.adminDetails;
  if (Array.isArray(responseData?.data?.adminDetails)) {
    return responseData.data.adminDetails;
  }
  if (Array.isArray(responseData?.User)) return responseData.User;
  if (Array.isArray(responseData?.users)) return responseData.users;
  if (Array.isArray(responseData)) return responseData;
  return [];
};

const getUserTabRows = (list = []) => {
  const activeOnly = list.filter((row) => row?.status === "Active");
  const source = activeOnly.length > 0 ? activeOnly : list;

  return source.filter((row) => {
    const roleName = String(
      row?.rolename?.roleName || row?.position || "",
    ).trim();

    const isAccount = !!(row?.account || row?.Account);

    return !isAccount && roleName !== "Customer" && roleName !== "Transporter";
  });
};

const getAccountTabRows = (list = []) =>
  list.filter((row) => !!(row?.account || row?.Account));

const getCustomerListFromResponse = (response) => {
  if (Array.isArray(response?.Customer)) return response.Customer;
  if (Array.isArray(response?.data?.Customer)) return response.data.Customer;
  if (Array.isArray(response?.customers)) return response.customers;
  if (Array.isArray(response)) return response;
  return [];
};

const getTransporterListFromResponse = (response) => {
  if (Array.isArray(response?.Transporter)) return response.Transporter;
  if (Array.isArray(response?.data?.Transporter)) {
    return response.data.Transporter;
  }
  if (Array.isArray(response?.transporters)) return response.transporters;
  if (Array.isArray(response)) return response;
  return [];
};

/* =========================================================
   CUSTOMER UPDATE HELPERS
========================================================= */

/* =========================================================
   CUSTOMER UPDATE HELPER

   IMPORTANT:
   Do NOT send the complete customer object back through FormData here.
   Fields such as `remark` are arrays of embedded MongoDB documents. If an
   existing array is appended to FormData with JSON.stringify, Express/Multer
   receives it as a STRING such as "[]". Passing that string directly to
   Mongoose causes:

   CastError: Cast to embedded failed for value "[]" at path "remark"

   This balance page only edits the fields below, so only those fields are
   submitted. All other customer fields remain unchanged in MongoDB.
========================================================= */
const buildCustomerUpdateFormData = (row, database) => {
  const formData = new FormData();

  // Fields editable from this page only.
  formData.append("CompanyName", String(row?.CompanyName || "").trim());

  formData.append(
    "comPanNo",
    String(row?.comPanNo || "")
      .trim()
      .toUpperCase(),
  );

  formData.append(
    "openingFinancialYear",
    normalizeFinancialYear(row?.openingFinancialYear || ""),
  );

  formData.append("OpeningBalance", String(safeNum(row?.OpeningBalance)));

  formData.append("Type", normalizeBalanceType(row?.Type || ""));

  if (database) {
    formData.append("database", database);
  }

  return formData;
};

/* =========================================================
   TRANSPORTER UPDATE HELPER

   Only submit fields editable from this balance page.
   Do NOT send serviceArea or any other array/object field through FormData,
   because embedded arrays can become JSON strings and cause Mongoose casts.
========================================================= */
const buildTransporterUpdateFormData = (row, database) => {
  const formData = new FormData();

  const companyName = String(row?.companyName || "").trim();

  formData.append("companyName", companyName);
  formData.append("id", String(row?.id || companyName.replace(/\s+/g, "")));

  formData.append(
    "gstNumber",
    String(row?.gstNumber || "")
      .trim()
      .toUpperCase(),
  );

  formData.append(
    "openingFinancialYear",
    normalizeFinancialYear(row?.openingFinancialYear || ""),
  );

  formData.append("OpeningBalance", String(safeNum(row?.OpeningBalance)));

  formData.append("Type", normalizeBalanceType(row?.Type || ""));

  if (database) {
    formData.append("database", database);
  }

  return formData;
};

/* =========================================================
   PRODUCT UPDATE HELPER

   Product Bulk Edit only changes the product fields shown on this page.
   Do not resend images, warehouse objects, categories, or other complex data.
========================================================= */
const buildProductUpdateFormData = (row, database) => {
  const formData = new FormData();

  formData.append(
    "Product_Title",
    String(row?.Product_Title || "")
      .trim()
      .toUpperCase(),
  );

  formData.append(
    "openingFinancialYear",
    normalizeFinancialYear(row?.openingFinancialYear || ""),
  );

  formData.append("Opening_Stock", String(safeNum(row?.Opening_Stock)));

  if (database) {
    formData.append("database", database);
  }

  return formData;
};

/* =========================================================
   PRODUCT / CLOSING STOCK HELPERS
   These mirror the calculation rules used by ClosingStockReport.jsx.
========================================================= */

const stockNum = (value) => (Number.isFinite(+value) ? +value : 0);

const stockNormId = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value;

  if (typeof value === "object") {
    if (value?._id) return String(value._id);
    if (value?.$oid) return String(value.$oid);
    if (value?.id) return String(value.id);
  }

  return String(value);
};

const stockFirstDefined = (...values) => {
  for (const value of values) {
    if (value !== undefined && value !== null && value !== "") {
      return value;
    }
  }

  return undefined;
};

const parseStockFYStart = (financialYear) => {
  const start = Number(
    String(normalizeFinancialYear(financialYear) || "").split("-")[0],
  );

  return Number.isFinite(start) ? start : 0;
};

const getPreviousStockFY = (financialYear) => {
  const start = parseStockFYStart(financialYear);

  if (!start) return "";

  return normalizeFinancialYear(`${start - 1}-${String(start).slice(-2)}`);
};

const buildStockDatabase = (database, financialYear) =>
  `${stripFinancialYearSuffix(database)}-${normalizeFinancialYear(financialYear)}`;

const stockSnapshotKey = (database, financialYear) =>
  `FY_CLOSING_STOCK_SNAPSHOT:${String(database || "")}:${normalizeFinancialYear(
    financialYear,
  )}`;

const getStockProductId = (row = {}) =>
  stockNormId(
    row?._productIdResolved ||
      row?._productDetailsFromProductList?._id ||
      row?._productDetailsFromProductList?.id ||
      row?.productId?._id ||
      row?.productId ||
      row?.pId ||
      row?.ProductId ||
      row?.product?._id ||
      "",
  );

const getStockWarehouseId = (row = {}) =>
  stockNormId(
    row?._warehouseIdResolved ||
      row?.warehouseId ||
      row?.warehouse?._id ||
      row?.warehouse ||
      row?.warehouseId1 ||
      row?.productId?.warehouse?._id ||
      row?.productId?.warehouse ||
      "",
  );

const getStockProductTitle = (row = {}) =>
  String(
    row?.Product_Title ||
      row?._productDetailsFromProductList?.Product_Title ||
      row?.productId?.Product_Title ||
      row?.product?.Product_Title ||
      row?.productName ||
      row?.ProductName ||
      "",
  )
    .trim()
    .toLowerCase();

const getStockLookupKeys = (row = {}) => {
  const keys = [];
  const warehouseId = getStockWarehouseId(row);
  const productId = getStockProductId(row);
  const title = getStockProductTitle(row);

  if (warehouseId && productId) keys.push(`${warehouseId}::${productId}`);
  if (warehouseId && title) keys.push(`${warehouseId}::title:${title}`);
  if (productId) keys.push(`id:${productId}`);
  if (title) keys.push(`title:${title}`);

  return [...new Set(keys.filter(Boolean))];
};

const findPreviousClosingForStockRow = (row, previousClosingMap = {}) => {
  const keys = getStockLookupKeys(row);

  for (const key of keys) {
    if (previousClosingMap?.[key]) {
      return previousClosingMap[key];
    }
  }

  return null;
};

const addPreviousClosingToStockMap = (map, row, closing) => {
  const keys = getStockLookupKeys(row);

  if (!keys.length) return;

  const payload = {
    closingQty: stockNum(closing?.closingQty),
    closingAveRate: stockNum(closing?.closingAveRate),
    closingTotal: stockNum(closing?.closingTotal),
  };

  keys.forEach((key) => {
    if (!map[key]) {
      map[key] = { ...payload };
      return;
    }

    const oldQty = stockNum(map[key]?.closingQty);
    const oldTotal = stockNum(map[key]?.closingTotal);
    const newQty = stockNum(payload.closingQty);
    const newTotal = stockNum(payload.closingTotal);

    const totalQty = oldQty + newQty;
    const totalValue = oldTotal + newTotal;

    map[key] = {
      closingQty: Number(totalQty.toFixed(2)),
      closingTotal: Number(totalValue.toFixed(2)),
      closingAveRate:
        totalQty > 0 ? Number((totalValue / totalQty).toFixed(2)) : 0,
    };
  });
};

const getStockOpeningFinancialYear = (row = {}) =>
  stockFirstDefined(
    row?._productDetailsFromProductList?.openingFinancialYear,
    row?._productDetailsFromProductList?.OpeningFinancialYear,
    row?.openingFinancialYear,
    row?.OpeningFinancialYear,
    row?.productId?.openingFinancialYear,
    row?.productId?.OpeningFinancialYear,
    row?.product?.openingFinancialYear,
    row?.product?.OpeningFinancialYear,
  );

const getProductSavedStockOpening = (row = {}) => {
  const product =
    row?._productDetailsFromProductList ||
    (row?.productId && typeof row.productId === "object"
      ? row.productId
      : {}) ||
    row?.product ||
    {};

  return {
    qty: stockNum(
      stockFirstDefined(
        product?.Opening_Stock,
        product?.openingStock,
        product?.openingQty,
        product?.oQty,
        row?.Opening_Stock,
        row?.openingStock,
        row?.openingQty,
        row?.oQty,
      ),
    ),

    rate: stockNum(
      stockFirstDefined(
        product?.openingRate,
        product?.Opening_Rate,
        product?.OpeningRate,
        product?.oRate,
        product?.purchaseRate,
        product?.PurchaseRate,
        product?.price,
        row?.openingRate,
        row?.oRate,
        row?.price,
      ),
    ),
  };
};

const loadPreviousStockSnapshotOpening = (database, financialYear, row) => {
  try {
    const previousFY = getPreviousStockFY(financialYear);

    const raw = localStorage.getItem(stockSnapshotKey(database, previousFY));

    const snapshot = raw ? JSON.parse(raw) : {};

    const item = findPreviousClosingForStockRow(row, snapshot);

    if (!item) return null;

    return {
      qty: stockNum(item?.closingQty),
      rate: stockNum(item?.closingAveRate),
    };
  } catch {
    return null;
  }
};

const getOpeningStockForFY = (
  row,
  financialYear,
  database,
  previousClosingMap = {},
) => {
  const openingFY = normalizeFinancialYear(getStockOpeningFinancialYear(row));

  const selectedStart = parseStockFYStart(financialYear);
  const openingStart = openingFY ? parseStockFYStart(openingFY) : null;

  const savedOpening = getProductSavedStockOpening(row);

  if (openingFY && openingStart > selectedStart) {
    return {
      qty: 0,
      rate: 0,
      source: `Product opening FY ${openingFY} is after selected FY`,
    };
  }

  if (openingFY && openingStart === selectedStart) {
    return {
      qty: stockNum(savedOpening.qty),
      rate: stockNum(savedOpening.rate),
      source: `Product opening (${openingFY})`,
    };
  }

  if (openingFY && openingStart < selectedStart) {
    const previousFromApi = findPreviousClosingForStockRow(
      row,
      previousClosingMap,
    );

    if (previousFromApi) {
      return {
        qty: stockNum(previousFromApi?.closingQty),
        rate: stockNum(previousFromApi?.closingAveRate),
        source: `Previous FY closing (${getPreviousStockFY(financialYear)})`,
      };
    }

    const snapshotOpening = loadPreviousStockSnapshotOpening(
      database,
      financialYear,
      row,
    );

    if (snapshotOpening) {
      return {
        ...snapshotOpening,
        source: `Previous FY closing snapshot (${getPreviousStockFY(
          financialYear,
        )})`,
      };
    }

    return {
      qty: 0,
      rate: 0,
      source: `Previous FY closing not found (${getPreviousStockFY(
        financialYear,
      )})`,
    };
  }

  return {
    qty: stockNum(
      stockFirstDefined(
        row?.oQty,
        row?.openingQty,
        row?.Opening_Stock,
        savedOpening.qty,
      ),
    ),

    rate: stockNum(
      stockFirstDefined(row?.openingRate, row?.oRate, savedOpening.rate),
    ),

    source: "Product saved opening",
  };
};

const normalizeStockRowsFromResponse = (response) => {
  if (Array.isArray(response?.data)) {
    return response.data;
  }

  if (!Array.isArray(response?.Warehouse)) {
    return [];
  }

  const output = [];

  response.Warehouse.forEach((warehouse) => {
    if (Array.isArray(warehouse?.productItems)) {
      warehouse.productItems.forEach((item, index) => {
        const productObject =
          item?.productId && typeof item.productId === "object"
            ? item.productId
            : {};

        output.push({
          ...item,

          _id:
            item?._id || `${warehouse?._id || warehouse?.warehouseId}-${index}`,

          warehouseId:
            warehouse?.warehouseId || warehouse?._id || warehouse?.warehouseId1,

          warehouse:
            item?.warehouse ||
            warehouse?.warehouseId ||
            warehouse?._id ||
            warehouse?.warehouseId1,

          Product_Title:
            item?.Product_Title ||
            productObject?.Product_Title ||
            item?.productName ||
            "",

          HSN_Code:
            item?.HSN_Code ||
            productObject?.HSN_Code ||
            productObject?.hsn ||
            "",

          productId: item?.productId,
        });
      });
    } else {
      output.push(warehouse);
    }
  });

  return output;
};

const buildStockProductDetailsMap = (products = []) => {
  const byId = new Map();
  const byTitle = new Map();
  const byWarehouseProductId = new Map();
  const byWarehouseTitle = new Map();

  (Array.isArray(products) ? products : []).forEach((product) => {
    const id = stockNormId(
      product?._id || product?.id || product?.productId || "",
    );

    const title = getStockProductTitle(product);
    const warehouseId = getStockWarehouseId(product);

    if (id) byId.set(id, product);
    if (title && !byTitle.has(title)) byTitle.set(title, product);

    if (warehouseId && id) {
      byWarehouseProductId.set(`${warehouseId}::${id}`, product);
    }

    if (warehouseId && title) {
      byWarehouseTitle.set(`${warehouseId}::${title}`, product);
    }
  });

  return {
    byId,
    byTitle,
    byWarehouseProductId,
    byWarehouseTitle,
  };
};

const findProductDetailsForStockRow = (row, productMap) => {
  const productId = getStockProductId(row);
  const warehouseId = getStockWarehouseId(row);
  const title = getStockProductTitle(row);

  if (warehouseId && productId) {
    const match = productMap?.byWarehouseProductId?.get(
      `${warehouseId}::${productId}`,
    );

    if (match) return match;
  }

  if (productId) {
    const match = productMap?.byId?.get(String(productId));

    if (match) return match;
  }

  if (warehouseId && title) {
    const match = productMap?.byWarehouseTitle?.get(`${warehouseId}::${title}`);

    if (match) return match;
  }

  if (title) {
    const match = productMap?.byTitle?.get(title);

    if (match) return match;
  }

  return null;
};

const mergeProductDetailsIntoStockRow = (row, productMap) => {
  const product = findProductDetailsForStockRow(row, productMap);

  if (!product) {
    return {
      ...row,
      _warehouseIdResolved: getStockWarehouseId(row),
      _productIdResolved: getStockProductId(row),
    };
  }

  return {
    ...row,

    _productDetailsFromProductList: product,

    _productIdResolved: stockNormId(
      product?._id || product?.id || row?.productId,
    ),

    _warehouseIdResolved:
      getStockWarehouseId(row) || getStockWarehouseId(product),

    Product_Title:
      row?.Product_Title ||
      row?.productId?.Product_Title ||
      product?.Product_Title ||
      "",

    HSN_Code:
      row?.HSN_Code || row?.productId?.HSN_Code || product?.HSN_Code || "",

    openingFinancialYear:
      product?.openingFinancialYear ||
      product?.OpeningFinancialYear ||
      row?.openingFinancialYear ||
      "",

    Opening_Stock: stockFirstDefined(
      product?.Opening_Stock,
      product?.openingStock,
      row?.Opening_Stock,
      row?.openingStock,
    ),

    openingRate: stockFirstDefined(
      product?.openingRate,
      product?.Opening_Rate,
      product?.OpeningRate,
      row?.openingRate,
      row?.oRate,
    ),
  };
};

const getInvoiceItemStockProductId = (item = {}) =>
  stockNormId(
    item?.productId?._id ||
      item?.productId?.id ||
      item?.productId ||
      item?.ProductId ||
      item?.product_id ||
      item?.product?._id ||
      "",
  );

const getInvoiceItemStockTitle = (item = {}) =>
  String(
    item?.productId?.Product_Title ||
      item?.productData?.Product_Title ||
      item?.product?.Product_Title ||
      item?.Product_Title ||
      item?.productName ||
      item?.ProductName ||
      "",
  )
    .trim()
    .toLowerCase();

const pendingStockStatuses = [
  "pending",
  "billing",
  "dispatch",
  "delivery boy assigned",
  "out for delivery",
];

const isPendingStockStatus = (status) => {
  const normalized = String(status || "")
    .trim()
    .toLowerCase();

  if (
    !normalized ||
    normalized.includes("cancel") ||
    normalized.includes("completed")
  ) {
    return false;
  }

  return pendingStockStatuses.some((code) => normalized.includes(code));
};

const buildSalesStockMap = (invoices = [], statusFilter = null) => {
  const bucket = {};

  const add = (key, qty, rate) => {
    if (!key || qty <= 0) return;

    if (!bucket[key]) {
      bucket[key] = {
        qty: 0,
        amount: 0,
      };
    }

    bucket[key].qty += qty;
    bucket[key].amount += qty * rate;
  };

  invoices.forEach((invoice) => {
    const status = String(invoice?.status || "").toLowerCase();

    if (statusFilter && !statusFilter(status)) {
      return;
    }

    const items = Array.isArray(invoice?.orderItems) ? invoice.orderItems : [];

    items.forEach((item) => {
      const qty = stockNum(
        item?.qty ??
          item?.quantity ??
          item?.Qty ??
          item?.productQty ??
          item?.saleQty,
      );

      const rate = stockNum(
        item?.price ??
          item?.rate ??
          item?.salesRate ??
          item?.saleRate ??
          item?.productId?.price,
      );

      const productId = getInvoiceItemStockProductId(item);
      const title = getInvoiceItemStockTitle(item);

      if (productId) add(`id:${productId}`, qty, rate);
      if (title) add(`title:${title}`, qty, rate);
    });
  });

  const result = {};

  Object.entries(bucket).forEach(([key, value]) => {
    result[key] = {
      qty: Number(stockNum(value.qty).toFixed(2)),
      rate: value.qty > 0 ? Number((value.amount / value.qty).toFixed(2)) : 0,
      total: Number(stockNum(value.amount).toFixed(2)),
    };
  });

  return result;
};

const buildPurchaseStockMap = (invoices = []) => {
  const bucket = {};

  const add = (key, qty, rate) => {
    if (!key || qty <= 0) return;

    if (!bucket[key]) {
      bucket[key] = {
        qty: 0,
        rateSum: 0,
        rateCount: 0,
      };
    }

    bucket[key].qty += qty;

    if (rate > 0) {
      bucket[key].rateSum += rate;
      bucket[key].rateCount += 1;
    }
  };

  invoices.forEach((invoice) => {
    const status = String(invoice?.status || "")
      .trim()
      .toLowerCase();

    if (!status.includes("completed")) return;

    const items = Array.isArray(invoice?.orderItems) ? invoice.orderItems : [];

    items.forEach((item) => {
      const qty = stockNum(
        item?.qty ??
          item?.quantity ??
          item?.Qty ??
          item?.productQty ??
          item?.pQty,
      );

      const rate = stockNum(
        item?.price ??
          item?.basicPrice ??
          item?.rate ??
          item?.purchaseRate ??
          item?.PurchaseRate ??
          item?.productId?.price,
      );

      const productId = getInvoiceItemStockProductId(item);
      const title = getInvoiceItemStockTitle(item);

      if (productId) add(`id:${productId}`, qty, rate);
      if (title) add(`title:${title}`, qty, rate);
    });
  });

  const result = {};

  Object.entries(bucket).forEach(([key, value]) => {
    const averageRate =
      value.rateCount > 0 ? value.rateSum / value.rateCount : 0;

    result[key] = {
      qty: Number(stockNum(value.qty).toFixed(2)),
      rate: Number(averageRate.toFixed(2)),
      total: Number((value.qty * averageRate).toFixed(2)),
    };
  });

  return result;
};

const findStockMovementForRow = (row, movementMap = {}) => {
  const productId = getStockProductId(row);

  if (productId && movementMap[`id:${productId}`]) {
    return movementMap[`id:${productId}`];
  }

  const title = getStockProductTitle(row);

  if (title && movementMap[`title:${title}`]) {
    return movementMap[`title:${title}`];
  }

  return {
    qty: 0,
    rate: 0,
    total: 0,
  };
};

const buildResolvedStockClosing = (row, opening, outward) => {
  const openingQty = stockNum(opening?.qty);
  const openingRate = stockNum(opening?.rate);

  const inwardQty = stockNum(row?.pQty);
  const inwardRate = stockNum(row?.avgPurchaseRate);

  const pendingQty = stockNum(row?.pendingStock);
  const outwardQty = stockNum(outward?.qty);

  const closingQty = Number(
    (openingQty + inwardQty - pendingQty - outwardQty).toFixed(2),
  );

  const openingTotal = openingQty * openingRate;

  const inwardTotal = inwardQty * inwardRate;

  const totalAvailableQty = openingQty + inwardQty;

  const totalAvailableValue = openingTotal + inwardTotal;

  const closingAveRate =
    totalAvailableQty > 0 ? totalAvailableValue / totalAvailableQty : 0;

  return {
    closingQty,

    closingAveRate: Number(closingAveRate.toFixed(2)),

    closingTotal: Number((closingQty * closingAveRate).toFixed(2)),
  };
};

/* =========================================================
   PDF IMAGE HELPERS
========================================================= */

const loadImageAsDataUrl = (url) =>
  new Promise((resolve) => {
    if (!url) {
      resolve(null);
      return;
    }

    const image = new Image();
    image.crossOrigin = "anonymous";

    image.onload = () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;

        const context = canvas.getContext("2d");
        context.drawImage(image, 0, 0);

        resolve(canvas.toDataURL("image/png"));
      } catch {
        resolve(null);
      }
    };

    image.onerror = () => resolve(null);
    image.src = url;
  });

const imgURL = (filename) => {
  if (!filename) return "";
  return `${baseURL}/Images/${filename}`;
};

/* =========================================================
   LIMITED CONCURRENT REQUEST HELPER
========================================================= */

const mapWithConcurrency = async (items, limit, asyncHandler) => {
  const source = Array.isArray(items) ? items : [];
  const results = new Array(source.length);
  let nextIndex = 0;

  const worker = async () => {
    while (true) {
      const currentIndex = nextIndex++;
      if (currentIndex >= source.length) return;

      try {
        results[currentIndex] = await asyncHandler(
          source[currentIndex],
          currentIndex,
        );
      } catch (error) {
        results[currentIndex] = {
          ...source[currentIndex],
          closingBalance: 0,
          closingType: "",
          _balanceError:
            error?.message || "Failed to calculate closing balance",
        };
      }
    }
  };

  const workerCount = Math.min(Math.max(limit, 1), source.length);

  await Promise.all(Array.from({ length: workerCount }, () => worker()));

  return results;
};

/* =========================================================
   COMPONENT
========================================================= */

export default function UserOpeningClosingBalance() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("users");

  const [userRows, setUserRows] = useState([]);
  const [accountRows, setAccountRows] = useState([]);
  const [customerRows, setCustomerRows] = useState([]);
  const [transporterRows, setTransporterRows] = useState([]);
  const [productRows, setProductRows] = useState([]);

  const [userSearch, setUserSearch] = useState("");
  const [accountSearch, setAccountSearch] = useState("");
  const [customerSearch, setCustomerSearch] = useState("");
  const [transporterSearch, setTransporterSearch] = useState("");
  const [productSearch, setProductSearch] = useState("");

  // Customer tab filter requested: All / Debitor / Creditor.
  const [customerPartyTypeFilter, setCustomerPartyTypeFilter] = useState("all");

  const [downloadOpen, setDownloadOpen] = useState(false);

  const [pageByTab, setPageByTab] = useState({
    users: 1,
    accounts: 1,
    customers: 1,
    transporters: 1,
    products: 1,
  });

  // Inline whole-column editor. Only stored/master fields are editable.
  // Closing balances/quantities remain calculation-only.
  const [columnEdit, setColumnEdit] = useState(null);
  const [columnDrafts, setColumnDrafts] = useState({});
  const [columnSaving, setColumnSaving] = useState(false);

  const [calculationProgress, setCalculationProgress] = useState({
    current: 0,
    total: 0,
  });

  // IMPORTANT FOR SPEED:
  // Only the currently opened tab is calculated. Other tabs keep their master
  // rows ready and are calculated on first open. This avoids hundreds of
  // ledger API requests during the initial page load.
  const [tabLoading, setTabLoading] = useState({
    users: false,
    accounts: false,
    customers: false,
    transporters: false,
    products: false,
  });

  const sourceRowsRef = useRef({
    users: [],
    accounts: [],
    customers: [],
    transporters: [],
    products: [],
  });

  const dataContextRef = useRef({ uid: "", database: "" });

  const calculatedTabsRef = useRef({
    users: false,
    accounts: false,
    customers: false,
    transporters: false,
    products: false,
  });

  const loadingTabsRef = useRef({
    users: false,
    accounts: false,
    customers: false,
    transporters: false,
    products: false,
  });

  // Cache in-flight/completed ledger reads for the life of this page.
  // Key = database + entity id + financial year.
  const ledgerCacheRef = useRef(new Map());

  // Product/stock request caches. These avoid duplicate invoice, purchase and
  // warehouse calls when all three displayed financial years are calculated.
  const stockInvoiceCacheRef = useRef(new Map());
  const stockInwardCacheRef = useRef(new Map());
  const stockWarehouseCacheRef = useRef(new Map());
  const previousProductClosingCacheRef = useRef(new Map());

  // This page always starts with the ACTUAL current FY, then the previous two.
  // It intentionally does not depend on financialYearSelected.
  const activeFY = useMemo(() => getCurrentFinancialYearLabel(), []);
  const displayFinancialYears = useMemo(
    () => getDisplayFinancialYears(activeFY),
    [activeFY],
  );

  const companyDetail = useMemo(
    () => JSON.parse(localStorage.getItem("Companydetail") || "{}"),
    [],
  );

  useEffect(() => {
    injectOnce();
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* =====================================================
     LEDGER FETCH
  ===================================================== */

  const fetchLedgerRowsForFY = async (targetId, database, financialYear) => {
    if (!targetId) return [];

    const normalizedFY = normalizeFinancialYear(financialYear);
    const cacheKey = `${stripFinancialYearSuffix(database)}::${targetId}::${normalizedFY}`;

    if (ledgerCacheRef.current.has(cacheKey)) {
      return ledgerCacheRef.current.get(cacheKey);
    }

    const requestPromise = (async () => {
      try {
        const selectedDatabase = buildDatabaseForFY(database, normalizedFY);
        const ledgerUrl = `${View_Ledger_by_id_database}${targetId}/`;
        const response = await _Get(ledgerUrl, selectedDatabase);

        const rawRows = Array.isArray(response?.Ledger) ? response.Ledger : [];

        // Same rule as the corrected Ledger page: only rows whose transaction
        // date actually belongs to this FY may affect this FY's balance.
        return rawRows.filter(
          (row) => getLedgerRowFinancialYear(row) === normalizedFY,
        );
      } catch (error) {
        console.warn(
          `[UserOpeningClosingBalance] No ledger for ${targetId}, FY ${normalizedFY}`,
          error,
        );
        return [];
      }
    })();

    // Store the Promise itself so duplicate/in-flight calls are also deduped.
    ledgerCacheRef.current.set(cacheKey, requestPromise);

    return requestPromise;
  };

  /* =====================================================
     CALCULATE OPENING + CLOSING BALANCE
     SAME LOGIC AS PartyLedgersView
     FOR USER / ACCOUNT / CUSTOMER / TRANSPORTER ONLY

     PRODUCT STOCK LOGIC BELOW IS NOT CHANGED.
  ===================================================== */

  const calculateClosingBalance = async (record, database) => {
    const recordId = record?._id || record?.id || "";

    const storedOpeningFY = normalizeFinancialYear(
      record?.openingFinancialYear || record?.OpeningFinancialYear || "",
    );

    // If older records have no opening FY saved, preserve the old page behavior
    // by treating the saved opening as belonging to the current FY.
    const resolvedOpeningFY = storedOpeningFY || activeFY;

    const masterOpeningBalance = Math.abs(
      safeNum(record?.OpeningBalance ?? record?.openingBalance ?? 0),
    );

    const masterOpeningType = normalizeBalanceType(
      record?.Type ?? record?.type ?? "",
    );

    const masterOpening = {
      openingFinancialYear: resolvedOpeningFY,
      OpeningBalance: masterOpeningBalance,
      Type: masterOpeningType,
    };

    const masterOpeningSigned = openingToSigned(masterOpening);
    const activeStart = getFYStartYear(activeFY);
    const openingStart = getFYStartYear(resolvedOpeningFY);

    /*
      For correct carry-forward we need every FY from the saved opening FY up to
      the current FY. The three displayed years are added explicitly so that
      historical columns still work when the master opening FY is newer.
    */
    const yearsToFetch = new Set(displayFinancialYears);

    if (openingStart > 0 && activeStart > 0 && openingStart <= activeStart) {
      for (let year = openingStart; year <= activeStart; year += 1) {
        yearsToFetch.add(makeFinancialYearLabel(year));
      }
    }

    const rowsByFYEntries = await Promise.all(
      [...yearsToFetch].map(async (financialYear) => [
        financialYear,
        await fetchLedgerRowsForFY(recordId, database, financialYear),
      ]),
    );

    const rowsByFY = Object.fromEntries(rowsByFYEntries);
    const movementByFY = {};

    Object.entries(rowsByFY).forEach(([financialYear, rows]) => {
      movementByFY[financialYear] = getLedgerRowsSignedMovement(rows);
    });

    const getOpeningSignedForYear = (financialYear) => {
      const targetStart = getFYStartYear(financialYear);

      if (!targetStart) return 0;

      // Before the record's master opening FY there is no carried opening.
      if (openingStart > 0 && targetStart < openingStart) {
        return 0;
      }

      if (openingStart > 0 && targetStart === openingStart) {
        return masterOpeningSigned;
      }

      if (openingStart > 0 && targetStart > openingStart) {
        let signed = masterOpeningSigned;

        for (let year = openingStart; year < targetStart; year += 1) {
          const fy = makeFinancialYearLabel(year);
          signed += safeNum(movementByFY[fy]);
        }

        return signed;
      }

      return financialYear === activeFY ? masterOpeningSigned : 0;
    };

    const yearBalances = {};

    displayFinancialYears.forEach((financialYear) => {
      const openingSigned = getOpeningSignedForYear(financialYear);
      const opening = signedBalanceInfo(openingSigned);

      const ledgerRows = rowsByFY[financialYear] || [];
      const movement = safeNum(movementByFY[financialYear]);
      const closingSigned = openingSigned + movement;
      const closing = signedBalanceInfo(closingSigned);

      yearBalances[financialYear] = {
        financialYear,
        openingBalance: opening.balance,
        openingType: opening.type,
        openingSigned,
        closingBalance: closing.balance,
        closingType: closing.type,
        closingSigned,
        ledgerRows: ledgerRows.length,
      };
    });

    const currentYearBalance = yearBalances[activeFY] || {
      openingBalance: 0,
      openingType: "",
      closingBalance: 0,
      closingType: "",
      openingSigned: 0,
      closingSigned: 0,
      ledgerRows: 0,
    };

    const currentRows = rowsByFY[activeFY] || [];

    return {
      ...record,

      // Keep the actual MASTER opening fields intact for editing.
      openingFinancialYear: storedOpeningFY,
      OpeningBalance: masterOpeningBalance,
      Type: masterOpeningType,

      // Three FY values shown by the new table.
      _yearBalances: yearBalances,

      // Backward-compatible current-FY fields used elsewhere on this page.
      effectiveOpeningFinancialYear: activeFY,
      effectiveOpeningBalance: currentYearBalance.openingBalance,
      effectiveOpeningType: currentYearBalance.openingType,
      _effectiveOpeningSigned: currentYearBalance.openingSigned,

      closingBalance: currentYearBalance.closingBalance,
      closingType: currentYearBalance.closingType,
      _closingSigned: currentYearBalance.closingSigned,
      _ledgerRows: currentYearBalance.ledgerRows,

      _resolvedCustomerPartyType:
        record?._listType === "customers"
          ? resolveCustomerPartySide(
              record,
              currentRows,
              currentYearBalance.closingType,
            )
          : "",
    };
  };

  /* =====================================================
     PRODUCT CLOSING STOCK
     Mirrors ClosingStockReport.jsx:
     Closing Qty = Opening Qty + Inward Qty - Pending Qty - Outward Qty
  ===================================================== */

  const getSalesInvoicesForStock = async (database, financialYear) => {
    const normalizedFY = normalizeFinancialYear(financialYear);
    const cacheKey = `${stripFinancialYearSuffix(database)}::sales::${normalizedFY}`;

    if (stockInvoiceCacheRef.current.has(cacheKey)) {
      return stockInvoiceCacheRef.current.get(cacheKey);
    }

    const requestPromise = (async () => {
      const selectedDatabase = buildStockDatabase(database, normalizedFY);
      const response = await createOrderhistoryviewDATABASE(selectedDatabase);

      return [
        ...(Array.isArray(response?.b2bData) ? response.b2bData : []),
        ...(Array.isArray(response?.b2csData) ? response.b2csData : []),
        ...(Array.isArray(response?.b2clData) ? response.b2clData : []),
        ...(Array.isArray(response?.orderHistory) ? response.orderHistory : []),
      ];
    })();

    stockInvoiceCacheRef.current.set(cacheKey, requestPromise);
    return requestPromise;
  };

  const loadOutwardStockMap = async (database, financialYear) => {
    try {
      const invoices = await getSalesInvoicesForStock(database, financialYear);

      return buildSalesStockMap(
        invoices,
        (status) =>
          String(status || "")
            .trim()
            .toLowerCase() === "completed",
      );
    } catch (error) {
      console.warn(
        "[UserOpeningClosingBalance] Product outward stock load failed:",
        error,
      );

      return {};
    }
  };

  const loadPendingStockMap = async (database, financialYear) => {
    try {
      const invoices = await getSalesInvoicesForStock(database, financialYear);

      return buildSalesStockMap(invoices, isPendingStockStatus);
    } catch (error) {
      console.warn(
        "[UserOpeningClosingBalance] Product pending stock load failed:",
        error,
      );

      return {};
    }
  };

  const loadInwardStockMap = async (uid, database, financialYear) => {
    const normalizedFY = normalizeFinancialYear(financialYear);
    const cacheKey = `${stripFinancialYearSuffix(database)}::inward::${uid}::${normalizedFY}`;

    if (stockInwardCacheRef.current.has(cacheKey)) {
      return stockInwardCacheRef.current.get(cacheKey);
    }

    const requestPromise = (async () => {
      try {
        const selectedDatabase = buildStockDatabase(database, normalizedFY);
        const response = await PurchaseOrderList(uid, selectedDatabase);

        const invoices = Array.isArray(response?.orderHistory)
          ? response.orderHistory
          : [];

        return buildPurchaseStockMap(invoices);
      } catch (error) {
        console.warn(
          "[UserOpeningClosingBalance] Product inward stock load failed:",
          error,
        );

        return {};
      }
    })();

    stockInwardCacheRef.current.set(cacheKey, requestPromise);
    return requestPromise;
  };

  const loadWarehouseStockRowsForFY = async (
    database,
    financialYear,
    productMap,
  ) => {
    const normalizedFY = normalizeFinancialYear(financialYear);
    const cacheKey = `${stripFinancialYearSuffix(database)}::warehouse::${normalizedFY}`;

    let requestPromise = stockWarehouseCacheRef.current.get(cacheKey);

    if (!requestPromise) {
      requestPromise = (async () => {
        const databaseParam = `${stripFinancialYearSuffix(
          database,
        )}?financialYear=${encodeURIComponent(normalizedFY)}`;

        const response = await _Get(WareHouse_Closing_Stock, databaseParam);
        return normalizeStockRowsFromResponse(response);
      })();

      stockWarehouseCacheRef.current.set(cacheKey, requestPromise);
    }

    const rawRows = await requestPromise;

    // Product details are merged AFTER the cached API read so an opening/name
    // edit uses the newest master values without re-downloading the warehouse.
    return rawRows.map((row) =>
      mergeProductDetailsIntoStockRow(row, productMap),
    );
  };

  const loadPreviousProductClosingMap = async (
    uid,
    database,
    financialYear,
    productMap,
    depth = 0,
  ) => {
    if (depth > 8) return {};

    const normalizedFY = normalizeFinancialYear(financialYear);
    const cacheKey = `${stripFinancialYearSuffix(
      database,
    )}::previous-closing::${normalizedFY}`;

    if (previousProductClosingCacheRef.current.has(cacheKey)) {
      return previousProductClosingCacheRef.current.get(cacheKey);
    }

    const requestPromise = (async () => {
      try {
        const previousFY = getPreviousStockFY(normalizedFY);
        if (!previousFY) return {};

        const rows = await loadWarehouseStockRowsForFY(
          database,
          previousFY,
          productMap,
        );

        const previousStart = parseStockFYStart(previousFY);

        const needsOlderClosing = rows.some((row) => {
          const openingFY = normalizeFinancialYear(
            getStockOpeningFinancialYear(row),
          );

          if (!openingFY) return false;
          return parseStockFYStart(openingFY) < previousStart;
        });

        const olderPreviousClosingMap = needsOlderClosing
          ? await loadPreviousProductClosingMap(
              uid,
              database,
              previousFY,
              productMap,
              depth + 1,
            )
          : {};

        const [outwardMap, pendingMap, inwardMap] = await Promise.all([
          loadOutwardStockMap(database, previousFY),
          loadPendingStockMap(database, previousFY),
          loadInwardStockMap(uid, database, previousFY),
        ]);

        const resultMap = {};

        rows.forEach((row) => {
          const opening = getOpeningStockForFY(
            row,
            previousFY,
            database,
            olderPreviousClosingMap,
          );

          const outward = findStockMovementForRow(row, outwardMap);
          const pending = findStockMovementForRow(row, pendingMap);
          const inward = findStockMovementForRow(row, inwardMap);

          const resolvedRow = {
            ...row,
            pQty: stockNum(inward?.qty),
            avgPurchaseRate: stockNum(inward?.rate),
            pendingStock: stockNum(pending?.qty),
          };

          const closing = buildResolvedStockClosing(
            resolvedRow,
            opening,
            outward,
          );

          addPreviousClosingToStockMap(resultMap, row, closing);
        });

        return resultMap;
      } catch (error) {
        console.warn(
          "[UserOpeningClosingBalance] Previous product closing load failed:",
          error,
        );

        return {};
      }
    })();

    previousProductClosingCacheRef.current.set(cacheKey, requestPromise);
    return requestPromise;
  };

  const calculateProductClosingRows = async (
    products,
    uid,
    database,
    financialYear,
  ) => {
    const productList = Array.isArray(products) ? products : [];

    if (!productList.length) {
      return [];
    }

    const normalizedFY = normalizeFinancialYear(financialYear);
    const productMap = buildStockProductDetailsMap(productList);

    try {
      const rawRows = await loadWarehouseStockRowsForFY(
        database,
        normalizedFY,
        productMap,
      );

      const [previousClosingMap, outwardMap, pendingMap, inwardMap] =
        await Promise.all([
          loadPreviousProductClosingMap(
            uid,
            database,
            normalizedFY,
            productMap,
          ),
          loadOutwardStockMap(database, normalizedFY),
          loadPendingStockMap(database, normalizedFY),
          loadInwardStockMap(uid, database, normalizedFY),
        ]);

      const resolvedRows = rawRows.map((row) => {
        const opening = getOpeningStockForFY(
          row,
          normalizedFY,
          database,
          previousClosingMap,
        );

        const outward = findStockMovementForRow(row, outwardMap);
        const pending = findStockMovementForRow(row, pendingMap);
        const inward = findStockMovementForRow(row, inwardMap);

        const resolvedRow = {
          ...row,
          pQty: stockNum(inward?.qty),
          avgPurchaseRate: stockNum(inward?.rate),
          pendingStock: stockNum(pending?.qty),
        };

        const closing = buildResolvedStockClosing(
          resolvedRow,
          opening,
          outward,
        );

        return {
          ...resolvedRow,
          _openingQtyResolved: stockNum(opening?.qty),
          _openingSourceResolved: opening?.source || "",
          closingQty: stockNum(closing?.closingQty),
        };
      });

      /*
        Closing Stock Report is warehouse-wise.
        This page is product-wise, so sum the closing quantity of the same
        product across all warehouse rows.
      */
      const closingById = new Map();
      const closingByTitle = new Map();

      resolvedRows.forEach((row) => {
        const productId = getStockProductId(row);
        const title = getStockProductTitle(row);
        const closingQty = stockNum(row?.closingQty);

        if (productId) {
          closingById.set(
            productId,
            stockNum(closingById.get(productId)) + closingQty,
          );
        }

        if (title) {
          closingByTitle.set(
            title,
            stockNum(closingByTitle.get(title)) + closingQty,
          );
        }
      });

      return productList.map((product) => {
        const productId = stockNormId(product?._id || product?.id);
        const title = getStockProductTitle(product);

        const closingQty =
          productId && closingById.has(productId)
            ? closingById.get(productId)
            : title && closingByTitle.has(title)
              ? closingByTitle.get(title)
              : 0;

        const productOpeningFY = normalizeFinancialYear(
          product?.openingFinancialYear || product?.OpeningFinancialYear || "",
        );

        const productOpeningStart = parseStockFYStart(productOpeningFY);
        const selectedStart = parseStockFYStart(normalizedFY);

        let effectiveOpeningQty = 0;

        if (!productOpeningFY) {
          effectiveOpeningQty =
            normalizedFY === activeFY
              ? stockNum(product?.Opening_Stock ?? product?.openingStock ?? 0)
              : 0;
        } else if (productOpeningStart > selectedStart) {
          effectiveOpeningQty = 0;
        } else if (productOpeningStart === selectedStart) {
          effectiveOpeningQty = stockNum(
            product?.Opening_Stock ?? product?.openingStock ?? 0,
          );
        } else {
          const previous = findPreviousClosingForStockRow(
            product,
            previousClosingMap,
          );

          effectiveOpeningQty = previous ? stockNum(previous?.closingQty) : 0;
        }

        return {
          ...product,
          openingFinancialYear: productOpeningFY,
          Opening_Stock: stockNum(
            product?.Opening_Stock ?? product?.openingStock ?? 0,
          ),
          effectiveOpeningQty: Number(stockNum(effectiveOpeningQty).toFixed(2)),
          closingQty: Number(stockNum(closingQty).toFixed(2)),
          _listType: "products",
        };
      });
    } catch (error) {
      console.error(
        "[UserOpeningClosingBalance] Product closing calculation failed:",
        error,
      );

      return productList.map((product) => ({
        ...product,
        openingFinancialYear: normalizeFinancialYear(
          product?.openingFinancialYear || product?.OpeningFinancialYear || "",
        ),
        Opening_Stock: stockNum(
          product?.Opening_Stock ?? product?.openingStock ?? 0,
        ),
        effectiveOpeningQty: 0,
        closingQty: 0,
        _listType: "products",
        _stockError: error?.message || "Closing stock calculation failed",
      }));
    }
  };

  /* =====================================================
     FAST / LAZY BALANCE CALCULATION
  ===================================================== */

  const setRowsForTab = (tabKey, rows) => {
    if (tabKey === "accounts") setAccountRows(rows);
    else if (tabKey === "customers") setCustomerRows(rows);
    else if (tabKey === "transporters") setTransporterRows(rows);
    else if (tabKey === "products") setProductRows(rows);
    else setUserRows(rows);
  };

  const calculateTabBalances = async (
    tabKey,
    { force = false, rowsOverride = null, contextOverride = null } = {},
  ) => {
    if (!tabKey) return;

    if (!force && calculatedTabsRef.current[tabKey]) return;
    if (loadingTabsRef.current[tabKey]) return;

    const sourceRows = Array.isArray(rowsOverride)
      ? rowsOverride
      : sourceRowsRef.current[tabKey] || [];

    const context = contextOverride || dataContextRef.current;
    const uid = context?.uid || "";
    const database = context?.database || "";

    if (!database) return;

    loadingTabsRef.current[tabKey] = true;
    setTabLoading((previous) => ({ ...previous, [tabKey]: true }));

    setCalculationProgress({ current: 0, total: sourceRows.length });

    try {
      let calculatedRows = [];

      if (tabKey === "products") {
        /*
          Calculate the three displayed FYs together. Shared invoice/purchase/
          warehouse caches mean duplicate network reads are automatically reused.
        */
        const productResults = await Promise.all(
          displayFinancialYears.map(async (financialYear) => [
            financialYear,
            await calculateProductClosingRows(
              sourceRows,
              uid,
              database,
              financialYear,
            ),
          ]),
        );

        const productRowsByFY = Object.fromEntries(productResults);

        calculatedRows = sourceRows.map((sourceRow, index) => {
          const currentRow = productRowsByFY?.[activeFY]?.[index] || sourceRow;

          const yearBalances = {};

          displayFinancialYears.forEach((financialYear) => {
            const yearRow = productRowsByFY?.[financialYear]?.[index] || {};

            yearBalances[financialYear] = {
              financialYear,
              openingQty: Number(
                stockNum(yearRow?.effectiveOpeningQty).toFixed(2),
              ),
              closingQty: Number(stockNum(yearRow?.closingQty).toFixed(2)),
            };
          });

          return {
            ...currentRow,
            _yearBalances: yearBalances,
            effectiveOpeningQty: yearBalances?.[activeFY]?.openingQty ?? 0,
            closingQty: yearBalances?.[activeFY]?.closingQty ?? 0,
          };
        });

        setCalculationProgress({
          current: sourceRows.length,
          total: sourceRows.length,
        });
      } else {
        let completed = 0;
        const progressStep = Math.max(
          1,
          Math.ceil(Math.max(sourceRows.length, 1) / 20),
        );

        calculatedRows = await mapWithConcurrency(
          sourceRows,
          BALANCE_REQUEST_CONCURRENCY,
          async (record) => {
            const result = await calculateClosingBalance(record, database);

            completed += 1;

            // Updating React state for every record makes large lists noticeably
            // slower. Update progress at ~5% intervals and once at completion.
            if (
              completed === sourceRows.length ||
              completed % progressStep === 0
            ) {
              setCalculationProgress({
                current: completed,
                total: sourceRows.length,
              });
            }

            return result;
          },
        );
      }

      setRowsForTab(tabKey, calculatedRows);
      calculatedTabsRef.current[tabKey] = true;
    } catch (error) {
      console.error(
        `[UserOpeningClosingBalance] ${tabKey} calculation failed:`,
        error,
      );

      setRowsForTab(tabKey, sourceRows);

      swal(
        "Unable to calculate balances",
        error?.message || `Unable to calculate ${tabKey}.`,
        "error",
      );
    } finally {
      loadingTabsRef.current[tabKey] = false;
      setTabLoading((previous) => ({ ...previous, [tabKey]: false }));
    }
  };

  /* =====================================================
     LOAD MASTER LISTS ONLY
     Ledger / stock calculations are lazy per tab.
  ===================================================== */

  const loadData = async (tabToCalculate = activeTab) => {
    setLoading(true);

    // Any master edit can change the opening balance, so a reload invalidates
    // all ledger results and tab calculations.
    ledgerCacheRef.current.clear();
    stockInvoiceCacheRef.current.clear();
    stockInwardCacheRef.current.clear();
    stockWarehouseCacheRef.current.clear();
    previousProductClosingCacheRef.current.clear();

    calculatedTabsRef.current = {
      users: false,
      accounts: false,
      customers: false,
      transporters: false,
      products: false,
    };

    loadingTabsRef.current = {
      users: false,
      accounts: false,
      customers: false,
      transporters: false,
      products: false,
    };

    setTabLoading({
      users: false,
      accounts: false,
      customers: false,
      transporters: false,
      products: false,
    });

    try {
      const userData = JSON.parse(localStorage.getItem("userData") || "{}");

      const uid = userData?._id || userData?.id || "";
      const database = userData?.database || userData?.db || "";

      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token") || "";

      if (!uid || !database) {
        throw new Error("Missing user ID or database in userData");
      }

      dataContextRef.current = { uid, database };

      const headers = token ? { Authorization: `Bearer ${token}` } : undefined;

      const userPath =
        typeof View_User_By_Id2 === "string" && View_User_By_Id2.trim()
          ? `${View_User_By_Id2.replace(/\/+$/, "")}/${uid}/${database}`
          : `/user/view-user-by-id/${uid}/${database}`;

      // These four master-list APIs run together and are the ONLY requests
      // that block the initial page shell from appearing.
      const [userResult, customerResult, transporterResult, productResult] =
        await Promise.allSettled([
          api.get(userPath, { headers }),
          CreateCustomerList(uid, database),
          _Get(Create_Transporter_List, database),
          _Get(PurchaseProductList_Product, database),
        ]);

      if (userResult.status !== "fulfilled") {
        throw userResult.reason || new Error("Unable to load users/accounts");
      }

      const allUserRows = extractUserList(userResult.value?.data);
      const users = getUserTabRows(allUserRows);
      const accounts = getAccountTabRows(allUserRows);

      const customers =
        customerResult.status === "fulfilled"
          ? getCustomerListFromResponse(customerResult.value)
          : [];

      const transporters =
        transporterResult.status === "fulfilled"
          ? getTransporterListFromResponse(transporterResult.value)
          : [];

      const products =
        productResult.status === "fulfilled" &&
        Array.isArray(productResult.value?.Product)
          ? productResult.value.Product
          : [];

      const normalizedRows = {
        users: users.map((row) => ({
          ...row,
          openingFinancialYear:
            row?.openingFinancialYear || row?.OpeningFinancialYear || "",
          OpeningBalance: row?.OpeningBalance ?? row?.openingBalance ?? 0,
          Type: row?.Type ?? row?.type ?? "",
          _listType: "users",
        })),

        accounts: accounts.map((row) => ({
          ...row,
          account: row?.account || row?.Account || "",
          openingFinancialYear:
            row?.openingFinancialYear || row?.OpeningFinancialYear || "",
          OpeningBalance: row?.OpeningBalance ?? row?.openingBalance ?? 0,
          Type: row?.Type ?? row?.type ?? "",
          _listType: "accounts",
        })),

        customers: customers.map((row) => ({
          ...row,
          openingFinancialYear:
            row?.openingFinancialYear || row?.OpeningFinancialYear || "",
          OpeningBalance: row?.OpeningBalance ?? row?.openingBalance ?? 0,
          Type: row?.Type ?? row?.type ?? "",
          partyType: row?.partyType || row?.PartyType || row?.party_type || "",
          _listType: "customers",
        })),

        transporters: transporters.map((row) => ({
          ...row,
          openingFinancialYear:
            row?.openingFinancialYear || row?.OpeningFinancialYear || "",
          OpeningBalance: row?.OpeningBalance ?? row?.openingBalance ?? 0,
          Type: row?.Type ?? row?.type ?? "",
          _listType: "transporters",
        })),

        products: products.map((row) => ({
          ...row,
          openingFinancialYear:
            row?.openingFinancialYear || row?.OpeningFinancialYear || "",
          Opening_Stock: stockNum(row?.Opening_Stock ?? row?.openingStock ?? 0),
          _listType: "products",
        })),
      };

      sourceRowsRef.current = normalizedRows;

      // Put master rows into state immediately. The active tab will show a
      // compact calculation loader until its accurate balances are ready.
      setUserRows(normalizedRows.users);
      setAccountRows(normalizedRows.accounts);
      setCustomerRows(normalizedRows.customers);
      setTransporterRows(normalizedRows.transporters);
      setProductRows(normalizedRows.products);

      if (customerResult.status !== "fulfilled") {
        console.warn(
          "[UserOpeningClosingBalance] Customers failed to load:",
          customerResult.reason,
        );
      }

      if (transporterResult.status !== "fulfilled") {
        console.warn(
          "[UserOpeningClosingBalance] Transporters failed to load:",
          transporterResult.reason,
        );
      }

      if (productResult.status !== "fulfilled") {
        console.warn(
          "[UserOpeningClosingBalance] Products failed to load:",
          productResult.reason,
        );
      }

      // Do NOT await this. The page becomes usable immediately after the four
      // master lists load; accurate balances calculate in the active tab only.
      window.setTimeout(() => {
        calculateTabBalances(tabToCalculate, {
          force: true,
          rowsOverride: normalizedRows[tabToCalculate] || [],
          contextOverride: { uid, database },
        });
      }, 0);
    } catch (error) {
      console.error("[UserOpeningClosingBalance] Load failed:", error);

      sourceRowsRef.current = {
        users: [],
        accounts: [],
        customers: [],
        transporters: [],
        products: [],
      };

      setUserRows([]);
      setAccountRows([]);
      setCustomerRows([]);
      setTransporterRows([]);
      setProductRows([]);

      swal(
        "Unable to load balances",
        error?.response?.data?.message ||
          error?.message ||
          "Something went wrong",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
    setDownloadOpen(false);
    setColumnEdit(null);
    setColumnDrafts({});

    if (!calculatedTabsRef.current[tabKey]) {
      calculateTabBalances(tabKey);
    }
  };

  /* =====================================================
     SEARCH
  ===================================================== */

  const applySearch = (list, searchText, type) => {
    const keyword = String(searchText || "")
      .trim()
      .toLowerCase();
    if (!keyword) return list;

    return list.filter((row) => {
      let values = [];

      if (type === "accounts") {
        values = [
          row?.firstName,
          row?.account,
          row?.Account,
          row?.openingFinancialYear,
          row?.OpeningBalance,
          row?.Type,
          row?.effectiveOpeningFinancialYear,
          row?.effectiveOpeningBalance,
          row?.effectiveOpeningType,
          row?.closingBalance,
          row?.closingType,
        ];
      } else if (type === "customers") {
        values = [
          row?.CompanyName,
          row?.ownerName,
          row?.comPanNo,
          row?.gstNumber,
          row?.contactNumber,
          row?.mobileNumber,
          row?.email,
          row?.City,
          row?.State,
          row?.pincode,
          row?.partyType,
          row?._resolvedCustomerPartyType,
          row?.openingFinancialYear,
          row?.OpeningBalance,
          row?.Type,
          row?.effectiveOpeningFinancialYear,
          row?.effectiveOpeningBalance,
          row?.effectiveOpeningType,
          row?.closingBalance,
          row?.closingType,
        ];
      } else if (type === "transporters") {
        values = [
          row?.companyName,
          row?.name,
          row?.gstNumber,
          row?.contactNumber,
          row?.email,
          row?.city,
          row?.City,
          row?.state,
          row?.State,
          row?.pincode,
          row?.openingFinancialYear,
          row?.OpeningBalance,
          row?.Type,
          row?.effectiveOpeningFinancialYear,
          row?.effectiveOpeningBalance,
          row?.effectiveOpeningType,
          row?.closingBalance,
          row?.closingType,
        ];
      } else if (type === "products") {
        values = [
          row?.Product_Title,
          row?.HSN_Code,
          row?.category,
          row?.SubCategory,
          row?.primaryUnit,
          row?.secondaryUnit,
          row?.warehouse?._id,
          row?.warehouse,
          row?.openingFinancialYear,
          row?.Opening_Stock,
          row?.closingQty,
        ];
      } else {
        values = [
          row?.firstName,
          row?.Pan_No,
          row?.panNo,
          row?.openingFinancialYear,
          row?.OpeningBalance,
          row?.Type,
          row?.effectiveOpeningFinancialYear,
          row?.effectiveOpeningBalance,
          row?.effectiveOpeningType,
          row?.closingBalance,
          row?.closingType,
        ];
      }

      return values
        .map((value) => toStr(value).toLowerCase())
        .join(" ")
        .includes(keyword);
    });
  };

  const userFiltered = useMemo(
    () => applySearch(userRows, userSearch, "users"),
    [userRows, userSearch],
  );

  const accountFiltered = useMemo(
    () => applySearch(accountRows, accountSearch, "accounts"),
    [accountRows, accountSearch],
  );

  const customerFiltered = useMemo(() => {
    const searched = applySearch(customerRows, customerSearch, "customers");

    if (customerPartyTypeFilter === "all") return searched;

    return searched.filter(
      (row) =>
        String(row?._resolvedCustomerPartyType || "").toLowerCase() ===
        customerPartyTypeFilter,
    );
  }, [customerRows, customerSearch, customerPartyTypeFilter]);

  const transporterFiltered = useMemo(
    () => applySearch(transporterRows, transporterSearch, "transporters"),
    [transporterRows, transporterSearch],
  );

  const productFiltered = useMemo(
    () => applySearch(productRows, productSearch, "products"),
    [productRows, productSearch],
  );

  const currentRows =
    activeTab === "accounts"
      ? accountFiltered
      : activeTab === "customers"
        ? customerFiltered
        : activeTab === "transporters"
          ? transporterFiltered
          : activeTab === "products"
            ? productFiltered
            : userFiltered;

  const currentSearch =
    activeTab === "accounts"
      ? accountSearch
      : activeTab === "customers"
        ? customerSearch
        : activeTab === "transporters"
          ? transporterSearch
          : activeTab === "products"
            ? productSearch
            : userSearch;

  const setCurrentSearch =
    activeTab === "accounts"
      ? setAccountSearch
      : activeTab === "customers"
        ? setCustomerSearch
        : activeTab === "transporters"
          ? setTransporterSearch
          : activeTab === "products"
            ? setProductSearch
            : setUserSearch;

  const currentPageRequested = pageByTab[activeTab] || 1;
  const pageCount = Math.max(1, Math.ceil(currentRows.length / PAGE_SIZE));
  const currentPage = Math.min(currentPageRequested, pageCount);

  const visibleRows = useMemo(() => {
    const startIndex = (currentPage - 1) * PAGE_SIZE;
    return currentRows.slice(startIndex, startIndex + PAGE_SIZE);
  }, [currentRows, currentPage]);

  useEffect(() => {
    if (currentPageRequested > pageCount) {
      setPageByTab((previous) => ({
        ...previous,
        [activeTab]: pageCount,
      }));
    }
  }, [activeTab, currentPageRequested, pageCount]);

  useEffect(() => {
    setPageByTab((previous) => ({
      ...previous,
      [activeTab]: 1,
    }));
  }, [
    activeTab,
    userSearch,
    accountSearch,
    customerSearch,
    transporterSearch,
    productSearch,
    customerPartyTypeFilter,
  ]);

  const setCurrentPage = (nextPage) => {
    const safePage = Math.max(1, Math.min(pageCount, nextPage));

    setPageByTab((previous) => ({
      ...previous,
      [activeTab]: safePage,
    }));
  };

  /* =====================================================
     DISPLAY HELPERS
  ===================================================== */

  const getParticularMain = (row) => {
    if (activeTab === "customers") {
      return row?.CompanyName || "-";
    }

    if (activeTab === "transporters") {
      return row?.companyName || "-";
    }

    if (activeTab === "products") {
      return row?.Product_Title || "-";
    }

    return row?.firstName || "-";
  };

  const getParticularSub = (row) => {
    if (activeTab === "accounts") {
      return row?.account || row?.Account || "-";
    }

    if (activeTab === "customers") {
      return `PAN: ${row?.comPanNo || "-"}`;
    }

    if (activeTab === "transporters") {
      return `GST: ${row?.gstNumber || "-"}`;
    }

    if (activeTab === "products") {
      return `HSN: ${row?.HSN_Code || "-"}`;
    }

    return `PAN: ${row?.Pan_No || row?.panNo || "-"}`;
  };

  const openLedgerForRow = (row) => {
    // Products are stock items and are not available in PartyLedgersView.
    if (activeTab === "products") return;

    const recordId = row?._id || row?.id || "";

    if (!recordId) {
      swal("Unable to open ledger", "Record ID is missing.", "warning");
      return;
    }

    navigate("/app/ledger", {
      state: {
        autoOpenLedger: {
          _id: recordId,
          id: recordId,
          fullName: getParticularMain(row),
          OpeningBalance: Math.abs(
            safeNum(row?.OpeningBalance ?? row?.openingBalance ?? 0),
          ),
          Type: row?.Type ?? row?.type ?? "",
          openingFinancialYear:
            row?.openingFinancialYear ?? row?.OpeningFinancialYear ?? "",
          sourceTab: activeTab,
        },
      },
    });
  };

  const getExportParticular = (row) => {
    if (activeTab === "accounts") {
      const account = row?.account || row?.Account || "";
      return account
        ? `${row?.firstName || ""} - ${account}`
        : row?.firstName || "";
    }

    if (activeTab === "customers") {
      return row?.comPanNo
        ? `${row?.CompanyName || ""} - PAN: ${row.comPanNo}`
        : row?.CompanyName || "";
    }

    if (activeTab === "transporters") {
      return row?.gstNumber
        ? `${row?.companyName || ""} - GST: ${row.gstNumber}`
        : row?.companyName || "";
    }

    if (activeTab === "products") {
      return row?.HSN_Code
        ? `${row?.Product_Title || ""} - HSN: ${row.HSN_Code}`
        : row?.Product_Title || "";
    }

    const pan = row?.Pan_No || row?.panNo || "";

    return pan ? `${row?.firstName || ""} - PAN: ${pan}` : row?.firstName || "";
  };

  const getCurrentTitle = () => {
    if (activeTab === "accounts") return "Account Balance List";
    if (activeTab === "customers") return "Customer Balance List";
    if (activeTab === "transporters") return "Transporter Balance List";
    if (activeTab === "products") return "Product Stock List";
    return "User Balance List";
  };

  const getCurrentSearchPlaceholder = () => {
    if (activeTab === "accounts") return "Search account...";
    if (activeTab === "customers") return "Search customer...";
    if (activeTab === "transporters") return "Search transporter...";
    if (activeTab === "products") return "Search product...";
    return "Search user...";
  };

  const getCurrentEntityName = () => {
    if (activeTab === "accounts") return "Account";
    if (activeTab === "customers") return "Customer";
    if (activeTab === "transporters") return "Transporter";
    if (activeTab === "products") return "Product";
    return "User";
  };

  const getRowKey = (row, fallback = "") =>
    String(row?._id || row?.id || fallback || "");

  const getYearBalance = (row, financialYear) =>
    row?._yearBalances?.[financialYear] || {};

  const getOpeningForYear = (row, financialYear) => {
    const yearData = getYearBalance(row, financialYear);

    if (activeTab === "products") {
      return {
        amount: stockNum(yearData?.openingQty),
        type: "",
      };
    }

    return {
      amount: safeNum(yearData?.openingBalance),
      type: normalizeBalanceType(yearData?.openingType),
    };
  };

  const getClosingForYear = (row, financialYear) => {
    const yearData = getYearBalance(row, financialYear);

    if (activeTab === "products") {
      return {
        amount: stockNum(yearData?.closingQty),
        type: "",
      };
    }

    return {
      amount: safeNum(yearData?.closingBalance),
      type: normalizeBalanceType(yearData?.closingType),
    };
  };

  const getParticularFieldName = () => {
    if (activeTab === "customers") return "CompanyName";
    if (activeTab === "transporters") return "companyName";
    if (activeTab === "products") return "Product_Title";
    if (activeTab === "accounts") return "firstName";
    return "";
  };

  const canEditParticularColumn = activeTab !== "users";

  /* =====================================================
     EXCEL DOWNLOAD
  ===================================================== */

  const downloadExcel = () => {
    if (!currentRows.length) {
      swal("No Data", "There are no records to download.", "warning");
      return;
    }

    const exportRows = currentRows.map((row) => {
      const output = {
        PARTICULARS: getExportParticular(row),
      };

      displayFinancialYears.forEach((financialYear, index) => {
        const opening = getOpeningForYear(row, financialYear);
        const closing = getClosingForYear(row, financialYear);
        const suffix = index + 1;

        output[`YEAR ${suffix}`] = financialYear;

        if (activeTab === "products") {
          output[`OPENING ${suffix}`] = stockNum(opening?.amount);
          output[`CLOSING ${suffix}`] = stockNum(closing?.amount);
        } else {
          output[`OPENING ${suffix}`] = formatBalance(
            opening?.amount,
            opening?.type,
          );

          output[`CLOSING ${suffix}`] = formatBalance(
            closing?.amount,
            closing?.type,
          );
        }
      });

      output["OPENING FINANCIAL YEAR"] = row?.openingFinancialYear || "";

      return output;
    });

    const worksheet = XLSX.utils.json_to_sheet(exportRows);

    worksheet["!cols"] = [
      { wch: 42 },
      { wch: 13 },
      { wch: 22 },
      { wch: 22 },
      { wch: 13 },
      { wch: 22 },
      { wch: 22 },
      { wch: 13 },
      { wch: 22 },
      { wch: 22 },
      { wch: 24 },
    ];

    const workbook = XLSX.utils.book_new();
    const sheetName = `${getCurrentEntityName()} Balances`;

    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    const buffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    saveAs(
      new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }),
      activeTab === "products"
        ? `Product_Opening_Closing_3FY_${activeFY}.xlsx`
        : `${getCurrentEntityName()}_Opening_Closing_3FY_${activeFY}.xlsx`,
    );

    setDownloadOpen(false);
  };

  /* =====================================================
     PDF DOWNLOAD - LEDGER STYLE
  ===================================================== */

  const downloadPDF = async () => {
    if (!currentRows.length) {
      swal("No Data", "There are no records to download.", "warning");
      return;
    }

    try {
      const strapLogoDataUrl = await loadImageAsDataUrl(RupioSoftLogo);
      const companyLogo = companyDetail?.logo
        ? await loadImageAsDataUrl(imgURL(companyDetail.logo))
        : null;

      // Landscape is required for the 11-column three-FY layout.
      const doc = new jsPDF("l", "mm", "a4");
      const pageWidth = doc.internal.pageSize.getWidth();

      let y = 8;

      doc.setFontSize(8);
      doc.text("THIS REPORT IS GENERATED IN", pageWidth / 2 - 13, y, {
        align: "right",
      });

      if (strapLogoDataUrl) {
        doc.addImage(strapLogoDataUrl, "PNG", pageWidth / 2 - 11, y - 3, 14, 4);
      }

      doc.text("SOFT", pageWidth / 2 + 6, y);
      y += 7;

      if (companyLogo) {
        const logoWidth = 42;
        const logoHeight = 15;

        doc.addImage(
          companyLogo,
          "PNG",
          (pageWidth - logoWidth) / 2,
          y,
          logoWidth,
          logoHeight,
        );

        y += logoHeight + 2;
      }

      const companyName = toStr(companyDetail?.name);
      const address = toStr(companyDetail?.address);
      const email = toStr(companyDetail?.email);
      const mobile = toStr(companyDetail?.mobileNo);

      if (companyName) {
        doc.setFontSize(13);
        doc.text(companyName, pageWidth / 2, y, { align: "center" });
        y += 5;
      }

      doc.setFontSize(8);

      if (address) {
        doc.text(address, pageWidth / 2, y, { align: "center" });
        y += 4;
      }

      if (email || mobile) {
        doc.text(
          [email, mobile].filter(Boolean).join(" | "),
          pageWidth / 2,
          y,
          { align: "center" },
        );
        y += 4;
      }

      doc.setFontSize(11);
      doc.text(
        activeTab === "products"
          ? `Product Opening & Closing Quantity - 3 Financial Years`
          : `${getCurrentEntityName()} Opening & Closing Balance - 3 Financial Years`,
        pageWidth / 2,
        y + 4,
        { align: "center" },
      );

      const head = [
        "Particulars",
        "Year",
        "Opening",
        "Closing",
        "Year",
        "Opening",
        "Closing",
        "Year",
        "Opening",
        "Closing",
        "Opening Financial Year",
      ];

      const body = currentRows.map((row) => {
        const cells = [getExportParticular(row)];

        displayFinancialYears.forEach((financialYear) => {
          const opening = getOpeningForYear(row, financialYear);
          const closing = getClosingForYear(row, financialYear);

          cells.push(financialYear);

          if (activeTab === "products") {
            cells.push(stockNum(opening?.amount).toFixed(2));
            cells.push(stockNum(closing?.amount).toFixed(2));
          } else {
            cells.push(formatBalanceForPdf(opening?.amount, opening?.type));
            cells.push(formatBalanceForPdf(closing?.amount, closing?.type));
          }
        });

        cells.push(row?.openingFinancialYear || "-");
        return cells;
      });

      autoTable(doc, {
        startY: y + 9,
        head: [head],
        body,
        theme: "grid",
        headStyles: {
          fillColor: [22, 160, 133],
          textColor: 255,
          halign: "center",
          valign: "middle",
          fontStyle: "bold",
        },
        styles: {
          fontSize: 6.6,
          cellPadding: 1.5,
          overflow: "linebreak",
          valign: "middle",
        },
        columnStyles: {
          0: { cellWidth: 45 },
          1: { cellWidth: 17, halign: "center" },
          2: { cellWidth: 24, halign: "right" },
          3: { cellWidth: 24, halign: "right" },
          4: { cellWidth: 17, halign: "center" },
          5: { cellWidth: 24, halign: "right" },
          6: { cellWidth: 24, halign: "right" },
          7: { cellWidth: 17, halign: "center" },
          8: { cellWidth: 24, halign: "right" },
          9: { cellWidth: 24, halign: "right" },
          10: { cellWidth: 25, halign: "center" },
        },
        margin: {
          left: 8,
          right: 8,
        },
        didDrawPage: () => {
          const pageNumber = doc.internal.getNumberOfPages();
          doc.setFontSize(7);

          doc.text(
            `Page ${pageNumber}`,
            pageWidth - 8,
            doc.internal.pageSize.getHeight() - 5,
            { align: "right" },
          );
        },
      });

      doc.save(
        activeTab === "products"
          ? `Product_Opening_Closing_3FY_${activeFY}.pdf`
          : `${getCurrentEntityName()}_Opening_Closing_3FY_${activeFY}.pdf`,
      );

      setDownloadOpen(false);
    } catch (error) {
      console.error("[UserOpeningClosingBalance] PDF failed:", error);

      swal(
        "PDF Download Failed",
        error?.message || "Unable to generate PDF.",
        "error",
      );
    }
  };

  /* =====================================================
     INLINE WHOLE-COLUMN EDIT
  ===================================================== */

  const persistBalanceRecord = async (row, database, createdBy) => {
    const recordId = row?._id || row?.id;

    if (!recordId) {
      throw new Error("Record ID not found");
    }

    if (activeTab === "products") {
      if (!String(row?.Product_Title || "").trim()) {
        throw new Error("Product Name is required");
      }

      const productFormData = buildProductUpdateFormData(row, database);

      const productEndpoint = String(Update_Product || "").replace(/\/+$/, "");

      const response = await _Put(productEndpoint, recordId, productFormData);

      if (response?.status === false) {
        throw new Error(response?.message || "Product update failed");
      }

      return response;
    }

    if (activeTab === "transporters") {
      if (!String(row?.companyName || "").trim()) {
        throw new Error("Transporter Name is required");
      }

      const transporterFormData = buildTransporterUpdateFormData(row, database);

      const response = await _Put(
        Update_TransporterByID,
        recordId,
        transporterFormData,
      );

      if (response?.status === false) {
        throw new Error(response?.message || "Transporter update failed");
      }

      return response;
    }

    if (activeTab === "customers") {
      if (!String(row?.CompanyName || "").trim()) {
        throw new Error("Company Name is required");
      }

      const customerFormData = buildCustomerUpdateFormData(row, database);

      const response = await CreateCustomerUpdate(recordId, customerFormData);

      if (response?.status === false) {
        throw new Error(response?.message || "Customer update failed");
      }

      return response;
    }

    let payload;

    if (activeTab === "accounts") {
      const firstName = String(row?.firstName || "")
        .trim()
        .toUpperCase();

      const account = String(row?.account || row?.Account || "").trim();

      if (!firstName) {
        throw new Error("Account name is required");
      }

      if (!account) {
        throw new Error("Account type is required");
      }

      if (!ACCOUNT_TYPES.includes(account)) {
        throw new Error("Invalid Account Type");
      }

      payload = {
        account,
        firstName,
        openingFinancialYear: normalizeFinancialYear(
          row?.openingFinancialYear || activeFY,
        ),
        OpeningBalance: safeNum(row?.OpeningBalance),
        Type: normalizeBalanceType(row?.Type),
        database,
        created_by: createdBy,
        id: `${firstName}-${account}`,
      };
    } else {
      payload = {
        openingFinancialYear: normalizeFinancialYear(
          row?.openingFinancialYear || activeFY,
        ),
        OpeningBalance: safeNum(row?.OpeningBalance),
        Type: normalizeBalanceType(row?.Type),
        database,
      };
    }

    const response = await CreateAccountUpdate(recordId, payload);

    if (response?.status === false) {
      throw new Error(response?.message || "Update failed");
    }

    return response;
  };

  const beginColumnEdit = (kind, financialYear = "") => {
    if (isCurrentTabLoading || columnSaving || !currentRows.length) return;

    const drafts = {};

    currentRows.forEach((row, index) => {
      const rowKey = getRowKey(row, index);
      if (!rowKey) return;

      if (kind === "particular") {
        drafts[rowKey] = {
          value: getParticularMain(row),
          dirty: false,
          error: "",
        };
      } else if (kind === "openingFinancialYear") {
        drafts[rowKey] = {
          value: row?.openingFinancialYear || "",
          dirty: false,
          error: "",
        };
      } else if (kind === "opening") {
        const opening = getOpeningForYear(row, financialYear);

        drafts[rowKey] = {
          amount: opening.amount,
          type: opening.type,
          dirty: false,
          error: "",
        };
      }
    });

    setColumnDrafts(drafts);
    setColumnEdit({
      kind,
      financialYear: normalizeFinancialYear(financialYear),
    });
  };

  const cancelColumnEdit = () => {
    if (columnSaving) return;
    setColumnEdit(null);
    setColumnDrafts({});
  };

  const updateColumnDraft = (rowKey, patch) => {
    setColumnDrafts((previous) => ({
      ...previous,
      [rowKey]: {
        ...(previous?.[rowKey] || {}),
        ...patch,
        dirty: true,
        error: "",
      },
    }));
  };

  const isEditingColumn = (kind, financialYear = "") =>
    columnEdit?.kind === kind &&
    (kind !== "opening" ||
      normalizeFinancialYear(columnEdit?.financialYear) ===
        normalizeFinancialYear(financialYear));

  const saveColumnChanges = async () => {
    if (!columnEdit || columnSaving) return;

    const changedEntries = Object.entries(columnDrafts).filter(
      ([, draft]) => draft?.dirty,
    );

    if (!changedEntries.length) {
      swal("No Changes", "You have not changed this column.", "info");
      return;
    }

    const confirmed = await swal({
      title: "Save column changes?",
      text: `${changedEntries.length} ${getCurrentEntityName().toLowerCase()} record(s) will be updated.`,
      icon: "warning",
      buttons: ["Cancel", "Save Changes"],
    });

    if (!confirmed) return;

    setColumnSaving(true);

    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const database = userData?.database || "";
    const createdBy = userData?._id || userData?.id || "";

    const sourceRows = sourceRowsRef.current[activeTab] || [];
    const sourceByKey = new Map(
      sourceRows.map((row, index) => [getRowKey(row, index), row]),
    );

    const successfulRows = new Map();
    const nextDrafts = { ...columnDrafts };

    let successCount = 0;
    let failedCount = 0;

    await mapWithConcurrency(changedEntries, 6, async ([rowKey, draft]) => {
      const sourceRow = sourceByKey.get(rowKey);

      if (!sourceRow) {
        nextDrafts[rowKey] = {
          ...draft,
          error: "Source record not found",
        };
        failedCount += 1;
        return;
      }

      let rowToSave = { ...sourceRow };

      if (columnEdit.kind === "particular") {
        const fieldName = getParticularFieldName();

        if (!fieldName) {
          nextDrafts[rowKey] = {
            ...draft,
            error: "This Particular column is read-only",
          };
          failedCount += 1;
          return;
        }

        let nextValue = String(draft?.value || "").trim();

        if (activeTab === "products" || activeTab === "accounts") {
          nextValue = nextValue.toUpperCase();
        }

        rowToSave = {
          ...rowToSave,
          [fieldName]: nextValue,
        };
      } else if (columnEdit.kind === "openingFinancialYear") {
        rowToSave = {
          ...rowToSave,
          openingFinancialYear: normalizeFinancialYear(draft?.value || ""),
        };
      } else if (columnEdit.kind === "opening") {
        if (activeTab === "products") {
          rowToSave = {
            ...rowToSave,
            openingFinancialYear: normalizeFinancialYear(
              columnEdit?.financialYear,
            ),
            Opening_Stock: stockNum(draft?.amount),
          };
        } else {
          rowToSave = {
            ...rowToSave,
            openingFinancialYear: normalizeFinancialYear(
              columnEdit?.financialYear,
            ),
            OpeningBalance: Math.abs(safeNum(draft?.amount)),
            Type: normalizeBalanceType(draft?.type) || "debit",
          };
        }
      }

      try {
        await persistBalanceRecord(rowToSave, database, createdBy);

        successfulRows.set(rowKey, rowToSave);
        nextDrafts[rowKey] = {
          ...draft,
          dirty: false,
          error: "",
        };
        successCount += 1;
      } catch (error) {
        nextDrafts[rowKey] = {
          ...draft,
          error:
            error?.response?.data?.message || error?.message || "Update failed",
        };
        failedCount += 1;
      }
    });

    const updatedSourceRows = sourceRows.map((row, index) => {
      const rowKey = getRowKey(row, index);
      return successfulRows.get(rowKey) || row;
    });

    sourceRowsRef.current = {
      ...sourceRowsRef.current,
      [activeTab]: updatedSourceRows,
    };

    setColumnDrafts(nextDrafts);

    if (successCount > 0) {
      /*
        Ledger transactions did not change, so keep ledgerCacheRef intact.
        This makes recalculation after an opening/name edit much faster.
      */
      if (activeTab === "products") {
        // Product opening details are used by the recursive previous-closing
        // calculation, so invalidate only that derived cache.
        previousProductClosingCacheRef.current.clear();
      }

      calculatedTabsRef.current[activeTab] = false;

      await calculateTabBalances(activeTab, {
        force: true,
        rowsOverride: updatedSourceRows,
      });
    }

    setColumnSaving(false);

    if (failedCount === 0) {
      setColumnEdit(null);
      setColumnDrafts({});
    }

    swal(
      "Column Update Completed",
      `Updated: ${successCount}\nFailed: ${failedCount}`,
      failedCount > 0 ? "warning" : "success",
    );
  };

  /* =====================================================
     LOADING
  ===================================================== */

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "18rem",
          gap: 12,
        }}
      >
        <Spinner
          style={{
            height: "4rem",
            width: "4rem",
          }}
          color="primary"
        />
      </div>
    );
  }

  /* =====================================================
     TAB INDICATOR
  ===================================================== */

  const activeIndex = Math.max(
    0,
    TABS.findIndex((tab) => tab.key === activeTab),
  );

  const tabWidthPercentage = 100 / TABS.length;
  const isCurrentTabLoading = !!tabLoading[activeTab];

  const renderColumnHeader = (
    label,
    kind,
    financialYear = "",
    editable = true,
  ) => {
    const editing = isEditingColumn(kind, financialYear);

    return (
      <div className="ucb-th-wrap">
        <span>{label}</span>

        {editable &&
          (editing ? (
            <>
              <button
                type="button"
                className="ucb-col-save-btn"
                title="Save this whole column"
                disabled={columnSaving}
                onClick={saveColumnChanges}
              >
                {columnSaving ? "…" : "✓"}
              </button>

              <button
                type="button"
                className="ucb-col-cancel-btn"
                title="Cancel column edit"
                disabled={columnSaving}
                onClick={cancelColumnEdit}
              >
                ×
              </button>
            </>
          ) : (
            <button
              type="button"
              className="ucb-col-edit-btn"
              title={`Bulk edit ${label}`}
              disabled={
                isCurrentTabLoading ||
                columnSaving ||
                !!columnEdit ||
                !currentRows.length
              }
              onClick={() => beginColumnEdit(kind, financialYear)}
            >
              <FaEdit size={11} />
            </button>
          ))}
      </div>
    );
  };

  /* =====================================================
     RENDER
  ===================================================== */

  return (
    <>
      <Row style={{ marginBottom: 10 }}>
        <Col sm="12">
          <div className="ucb-shell">
            {/* ================= TABS ================= */}

            <div className="ucb-tabsbar">
              <div className="ucb-tabswrap">
                <div className="ucb-tabs">
                  <div
                    className="ucb-indicator"
                    style={{
                      width: `${tabWidthPercentage}%`,
                      transform: `translateX(${activeIndex * 100}%)`,
                    }}
                  />

                  {TABS.map((tab) => (
                    <button
                      key={tab.key}
                      type="button"
                      className={`ucb-tab ${
                        activeTab === tab.key ? "active" : ""
                      }`}
                      onClick={() => handleTabChange(tab.key)}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* ================= ACTION BAR ================= */}

            <div className="ucb-actionbar">
              <div className="ucb-actionrow">
                <div className="ucb-title">
                  {getCurrentTitle()}
                  <span className="ucb-count">{currentRows.length}</span>
                </div>

                {isCurrentTabLoading && (
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 7,
                      fontSize: 12,
                      fontWeight: 800,
                      color: "#64748b",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <Spinner size="sm" />
                    Calculating {calculationProgress.current}/
                    {calculationProgress.total}
                  </div>
                )}

                <div className="ucb-spacer" />

                {activeTab === "customers" && (
                  <Input
                    type="select"
                    value={customerPartyTypeFilter}
                    disabled={
                      isCurrentTabLoading || !!columnEdit || columnSaving
                    }
                    onChange={(event) =>
                      setCustomerPartyTypeFilter(event.target.value)
                    }
                    style={{
                      width: 170,
                      height: 40,
                      borderRadius: 14,
                      fontWeight: 800,
                    }}
                    title="Filter customers by party type"
                  >
                    <option value="all">All Party Types</option>
                    <option value="debitor">Debitor</option>
                    <option value="creditor">Creditor</option>
                  </Input>
                )}

                <input
                  className="ucb-search"
                  placeholder={getCurrentSearchPlaceholder()}
                  value={currentSearch}
                  disabled={isCurrentTabLoading || !!columnEdit || columnSaving}
                  onChange={(event) => setCurrentSearch(event.target.value)}
                />

                <div className="ucb-download-wrap">
                  <button
                    type="button"
                    className="ucb-btn-soft"
                    disabled={
                      isCurrentTabLoading ||
                      !currentRows.length ||
                      !!columnEdit ||
                      columnSaving
                    }
                    onClick={() => setDownloadOpen((previous) => !previous)}
                  >
                    <FaDownload size={14} />
                    DOWNLOAD
                    <FaChevronDown size={10} />
                  </button>

                  {downloadOpen && (
                    <div className="ucb-download-menu">
                      <button
                        type="button"
                        className="ucb-download-item"
                        onClick={downloadExcel}
                      >
                        <FaFileExcel size={16} />
                        Download Excel
                      </button>

                      <button
                        type="button"
                        className="ucb-download-item"
                        onClick={downloadPDF}
                      >
                        <FaFilePdf size={16} />
                        Download PDF
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* ================= TABLE ================= */}

            <Card className="ucb-table-card">
              {isCurrentTabLoading ? (
                <div
                  className="ucb-empty"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 10,
                  }}
                >
                  <Spinner size="sm" color="primary" />
                  Calculating accurate {getCurrentEntityName().toLowerCase()}
                  balances... {calculationProgress.current}/
                  {calculationProgress.total}
                </div>
              ) : !currentRows.length ? (
                <div className="ucb-empty">
                  No {getCurrentEntityName().toLowerCase()} records found.
                </div>
              ) : (
                <div className="ucb-table-wrap">
                  <table className="ucb-table">
                    <thead>
                      <tr>
                        <th>
                          {renderColumnHeader(
                            "PARTICULARS",
                            "particular",
                            "",
                            canEditParticularColumn,
                          )}
                        </th>

                        {displayFinancialYears.map((financialYear) => (
                          <React.Fragment key={`head-${financialYear}`}>
                            <th>YEAR</th>

                            <th>
                              {renderColumnHeader(
                                "OPENING",
                                "opening",
                                financialYear,
                                true,
                              )}
                            </th>

                            <th>CLOSING</th>
                          </React.Fragment>
                        ))}

                        <th>
                          {renderColumnHeader(
                            "OPENING FINANCIAL YEAR",
                            "openingFinancialYear",
                            "",
                            true,
                          )}
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {visibleRows.map((row, index) => {
                        const absoluteIndex =
                          (currentPage - 1) * PAGE_SIZE + index;
                        const rowKey = getRowKey(row, absoluteIndex);
                        const draft = columnDrafts?.[rowKey] || {};

                        return (
                          <tr key={rowKey || absoluteIndex}>
                            <td
                              className={
                                isEditingColumn("particular")
                                  ? "ucb-editing-cell"
                                  : ""
                              }
                            >
                              <div className="ucb-particular">
                                {isEditingColumn("particular") ? (
                                  <>
                                    <input
                                      className="ucb-inline-input ucb-inline-name"
                                      value={draft?.value ?? ""}
                                      onChange={(event) =>
                                        updateColumnDraft(rowKey, {
                                          value: event.target.value,
                                        })
                                      }
                                    />

                                    <div className="ucb-sub-name">
                                      {getParticularSub(row)}
                                    </div>

                                    {!!draft?.error && (
                                      <div className="ucb-error-text">
                                        {draft.error}
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {activeTab === "products" ? (
                                      <div className="ucb-main-name">
                                        {getParticularMain(row)}
                                      </div>
                                    ) : (
                                      <button
                                        type="button"
                                        className="ucb-ledger-link"
                                        title={`Open ${getParticularMain(row)} ledger`}
                                        onClick={() => openLedgerForRow(row)}
                                      >
                                        {getParticularMain(row)}
                                      </button>
                                    )}

                                    <div className="ucb-sub-name">
                                      {getParticularSub(row)}
                                    </div>
                                  </>
                                )}
                              </div>
                            </td>

                            {displayFinancialYears.map(
                              (financialYear, yearIndex) => {
                                const opening = getOpeningForYear(
                                  row,
                                  financialYear,
                                );

                                const closing = getClosingForYear(
                                  row,
                                  financialYear,
                                );

                                const editingOpening = isEditingColumn(
                                  "opening",
                                  financialYear,
                                );

                                const currentYearClass =
                                  yearIndex === 0
                                    ? "ucb-current-year-cell"
                                    : "";

                                return (
                                  <React.Fragment
                                    key={`${rowKey}-${financialYear}`}
                                  >
                                    <td className={currentYearClass}>
                                      <span className="ucb-fy-pill">
                                        {financialYear}
                                      </span>
                                    </td>

                                    <td
                                      className={`${currentYearClass} ${
                                        editingOpening ? "ucb-editing-cell" : ""
                                      }`}
                                    >
                                      {editingOpening ? (
                                        activeTab === "products" ? (
                                          <>
                                            <input
                                              type="number"
                                              min="0"
                                              step="0.01"
                                              className="ucb-inline-input"
                                              value={draft?.amount ?? ""}
                                              onChange={(event) =>
                                                updateColumnDraft(rowKey, {
                                                  amount: event.target.value,
                                                })
                                              }
                                            />

                                            {!!draft?.error && (
                                              <div className="ucb-error-text">
                                                {draft.error}
                                              </div>
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            <div className="ucb-inline-balance">
                                              <input
                                                type="number"
                                                min="0"
                                                step="0.01"
                                                className="ucb-inline-input"
                                                value={draft?.amount ?? ""}
                                                onChange={(event) =>
                                                  updateColumnDraft(rowKey, {
                                                    amount: event.target.value,
                                                  })
                                                }
                                              />

                                              <select
                                                className="ucb-inline-type"
                                                value={
                                                  normalizeBalanceType(
                                                    draft?.type,
                                                  ) || "debit"
                                                }
                                                onChange={(event) =>
                                                  updateColumnDraft(rowKey, {
                                                    type: event.target.value,
                                                  })
                                                }
                                              >
                                                <option value="debit">
                                                  Dr
                                                </option>
                                                <option value="credit">
                                                  Cr
                                                </option>
                                              </select>
                                            </div>

                                            {!!draft?.error && (
                                              <div className="ucb-error-text">
                                                {draft.error}
                                              </div>
                                            )}
                                          </>
                                        )
                                      ) : activeTab === "products" ? (
                                        <span className="ucb-money">
                                          {stockNum(opening?.amount).toFixed(2)}
                                        </span>
                                      ) : (
                                        <>
                                          <span className="ucb-money">
                                            ₹ {formatAmount(opening?.amount)}
                                          </span>

                                          {!!opening?.type && (
                                            <span className="ucb-balance-type">
                                              {opening.type === "credit"
                                                ? "Cr"
                                                : "Dr"}
                                            </span>
                                          )}
                                        </>
                                      )}
                                    </td>

                                    <td className={currentYearClass}>
                                      {activeTab === "products" ? (
                                        <span className="ucb-money">
                                          {stockNum(closing?.amount).toFixed(2)}
                                        </span>
                                      ) : (
                                        <>
                                          <span className="ucb-money">
                                            ₹ {formatAmount(closing?.amount)}
                                          </span>

                                          {!!closing?.type && (
                                            <span className="ucb-balance-type">
                                              {closing.type === "credit"
                                                ? "Cr"
                                                : "Dr"}
                                            </span>
                                          )}
                                        </>
                                      )}
                                    </td>
                                  </React.Fragment>
                                );
                              },
                            )}

                            <td
                              className={
                                isEditingColumn("openingFinancialYear")
                                  ? "ucb-editing-cell"
                                  : ""
                              }
                            >
                              {isEditingColumn("openingFinancialYear") ? (
                                <>
                                  <input
                                    className="ucb-inline-input"
                                    placeholder="2026-27"
                                    value={draft?.value ?? ""}
                                    onChange={(event) =>
                                      updateColumnDraft(rowKey, {
                                        value: event.target.value,
                                      })
                                    }
                                  />

                                  {!!draft?.error && (
                                    <div className="ucb-error-text">
                                      {draft.error}
                                    </div>
                                  )}
                                </>
                              ) : (
                                <span className="ucb-fy-pill">
                                  {row?.openingFinancialYear || "-"}
                                </span>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>

                  {pageCount > 1 && (
                    <div className="ucb-pagination">
                      <span>
                        Showing {(currentPage - 1) * PAGE_SIZE + 1}-
                        {Math.min(currentPage * PAGE_SIZE, currentRows.length)}{" "}
                        of {currentRows.length}
                      </span>

                      <button
                        type="button"
                        className="ucb-page-btn"
                        disabled={currentPage <= 1}
                        onClick={() => setCurrentPage(currentPage - 1)}
                      >
                        Previous
                      </button>

                      <span>
                        Page {currentPage} / {pageCount}
                      </span>

                      <button
                        type="button"
                        className="ucb-page-btn"
                        disabled={currentPage >= pageCount}
                        onClick={() => setCurrentPage(currentPage + 1)}
                      >
                        Next
                      </button>
                    </div>
                  )}
                </div>
              )}
            </Card>
          </div>
        </Col>
      </Row>
    </>
  );
}
